
declare const google: any;

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Signal,
  signal,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { BehaviorSubject, firstValueFrom, lastValueFrom, Observable, of, Subject, Subscription, timer } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
// import { User, WalletInfo } from 'app/core/user/user.types';
// import moment, { Moment } from 'moment-timezone';
// import moment, { Moment } from 'moment';

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { nanoid } from 'nanoid';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ActivatedRoute, Router, ExtraOptions, RouterLink, RouterOutlet } from '@angular/router';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { DOCUMENT, isPlatformBrowser, NgClass } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
// import { DenseLayoutComponent } from 'app/layout/layouts/vertical/dense/dense.component';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';

import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TaxisService } from '../../services/order.service';
import { FuseSplashScreenService } from '../../../@fuse/splash-screen/splash-screen.service';
import { ClientService } from '../../services/client-service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';

import { fuseAnimations } from '../../../@fuse/animations';
import { WalletService } from '../../services/wallet-dashboard.service';
import { TermsPolicyDialog } from '../../components/terms-policy/terms.component';
import { TermsCGUDialog } from '../../components/terms-cgu/terms.component';
import { environment } from '../../../environments/environment';
import { TopUpDialogComponent } from '../../components/topup-options-dialog/dialog.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { NgCreditCardModule } from 'angular-credit-card';
import { FuseCardComponent } from '../../../@fuse/components/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { SharedModule } from '../../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Console, error } from 'console';
import * as socketClusterClient from 'socketcluster-client';
import { escape, set } from 'lodash';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpLoaderFactory } from '../../app.config';
import { AgmMapComponent } from '../../components/agm-map-component/agm-map-component';
import { ExpandablePanelComponent } from '../../components/agm-map-component/expandable-panel/expandable-panel.component';
// import { TicketConfirmationComponent } from '../../components/ticket-confirmation/ticket-confirmation';
import { TranslationService } from '../../services/translation.service';
import { DistanceFormatPipe } from '../../pipes/distance-format.pipe';
import { TripReviewsComponent } from '../../components/trip-reviews/trip-reviews.component';
import { DriverReviewsComponent } from '../../components/driver-reviews/driver-reviews.components';
// import { TicketClientComponent } from '../../components/ticket-client/ticket-client.component';
import { TripNotificationComponent } from '../../components/trip-notification/trip-notification.component';

// moment.tz.setDefault('AfChangeDetectorRefrica/Casablanca');
import 'moment/locale/fr';
import { throws } from 'assert';
import { ShowTicketComponent } from '../../components/show-ticket/show-ticket.component';
import { ChatbotService } from '../../services/chatbot.service';
import { SeoService } from '../../services/seo.service';
import { CityLinksComponent } from '../../components/city-links/city-links.component';
import { TripCancellationDialogComponent } from '../../components/trip-cancellation-dialog/trip-cancellation-dialog.component';
import { CityEnum } from '../../models/city.enum';
import { MetaDataService } from '../../services/meta-data.service';
import { GoogleMapsService } from '../../services/google-maps.service';


const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
//declare const google: any;
export interface Review{
  orderId: string;
  ratingA?: string;
  ratingB?: string;
  ratingC?: string;
  review_emoji?: number;
  comment?: string;
}
@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: true,
  imports: [   
    TripReviewsComponent,
    DriverReviewsComponent,
    // TicketClientComponent,
    MatFormFieldModule,
    RouterOutlet,
    MatDatepickerModule,
    MatMomentDateModule,
    MatInputModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    TranslocoModule,
    MatSelectModule,
    MatStepperModule,
    MatTabsModule,
    NgClass,
    ReactiveFormsModule,
    NgCreditCardModule,
    MatMenuModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    NgxMatTimepickerModule,
    NgxSliderModule,
    MatDialogModule,
    CdkStepperModule,
    TranslateModule,
    AgmMapComponent,
    ExpandablePanelComponent,
    TripNotificationComponent,
    // TicketConfirmationComponent,
    DistanceFormatPipe,
    ShowTicketComponent,
    CityLinksComponent,
    SharedModule, MatTooltipModule, TranslateModule, MatStepperModule, ReactiveFormsModule],
  styles: [
    /* language=SCSS */
    `
      .smart-order-grid {
        grid-template-columns: 30px 40px 80px auto 50px;
      }
      .create-command-grid-order {
        grid-template-columns: 10px auto 100px 80px 0px;
      }
      .create-command-grid-order22 {
        grid-template-columns: auto 80px 0px;
      }
      .create-command-grid-order221 {
        grid-template-columns: 80px 0px auto;
      }
      .create-command-grid-order-33 {
        grid-template-columns: 80px auto 0px;
      }
      .create-command-grid-order-331 {
        grid-template-columns: 0px auto 80px;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fuseAnimations,
    trigger('rotateAnimation', [
      state(
        'initial',
        style({
          transform: 'rotate(0deg)',
        })
      ),
      state(
        'rotated',
        style({
          transform: 'rotate(-90deg)',
        })
      ),
      transition('initial => rotated', animate('700ms ease-in')),
      transition('rotated => initial', animate('700ms ease-out')),
    ]),
  ],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: CdkStepper, useClass: CdkStepper },
    {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
    
    
  ],
})
export class LandingComponent implements OnInit, OnDestroy, AfterViewInit {
  isProcessingPayment = signal(false);
  @ViewChild('loungeStepper')
   loungeStepper!: MatStepper;
  @ViewChild('quotanoSteps') quotaSteps!: MatTabGroup;
  @ViewChild('paymentStepper') paymentStepper!: MatStepper;
  CityEnum: typeof CityEnum = CityEnum;

  @ViewChild('initialAddressRef') initialAddressRef!: ElementRef;
  @ViewChild('destinationAddressRef') destinationAddressRef!: ElementRef;
  departureControl: FormControl = new FormControl('');
  arriveControl: FormControl = new FormControl('');
  loungesData: any = [];
  dynamicHtml: SafeHtml="";
  isBrowser = false;
  driversNotify: any[] = [];
  isExpanded = false;

@ViewChild('stepperNextBtn') stepperNextBtn!: ElementRef<HTMLButtonElement>;

  successIcon:string = 'mat_outline:check';
  infoIcon = 'mat_outline:info';

  timezone = 'Africa/Casablanca';

  // taxis$: Observable<Taxi[]>;
  flashMessage: 'success' | 'error' | null = null;
  isLoading: boolean = false;
  searchInputControl: FormControl = new FormControl();
  selectedOrderForm!: FormGroup;

  isInStepOne: boolean = true;

  //! Will use this as a subject for QTY/LUGGAGE debouncer
  pricingControl: FormControl = new FormControl();

  formattedaddress = ' ';
  options = {
    componentRestrictions: { country: 'ma' },
    fields: ['address_components', 'geometry', 'name'],
  };

  token:string=''
  iframeToken: string = '';
  cityId: CityEnum = CityEnum.MARRAKECH;

  eventForm!: FormGroup;
  eventForm1!: FormGroup;
  billingForm: FormGroup;
  deliveryForm!: FormGroup;
  paymentForm: FormGroup;
  countries:any[] = [];
  filteredCountries:any[] = [];
  countriesSearch: FormControl = new FormControl('');
  months = [];
  years = [];
  retailers: any[] = [];
  popularSecteurs:any[] = [];

  secteursFetchingLoading: boolean = false;

  currency = '$';

  totalPriceTTC: number = 0;
  totalPriceHT: number = 0;
  totalPriceTVA: number = 0;
  totalRemise: number = 0;
  totalCount: number = 0;
  totalCleanPriceHT: number = 0;
  totalPriceToDisplay: number = 0;
  totalPriceOptions: number = 0;

  times = [];
  adultTypes = [
    'Mr.',
    'Mrs',
    'Ms.',
    'Miss',
    'Dr.',
    'Prof.',
    'Sir',
    'Lady',
    '--',
  ];
  adultItems: any[] = [];
  childrenItems: any[] = [];
  babiesItems: any[] = [];

  isShowTicket: boolean = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  currentDate = '';
  socket : any = null;
myDateFilter: (d: Date | null) => boolean = (d: Date | null): boolean => {
  if (!d) return false;

  const timeZone = 'Africa/Casablanca';
  const today = new Date();

  // Obtenir la date "jour" dans le fuseau horaire
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  const todayParts = formatter.format(today).split('/');
  const dateParts = formatter.format(d).split('/');

  // Comparer YYYY-MM-DD
  const todayStr = `${todayParts[2]}-${todayParts[0]}-${todayParts[1]}`;
  const dateStr = `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`;

  return dateStr >= todayStr;
};

  ticketId:string='';
  status: string = '';

  currentTripStatus = signal<number>(0);
  //! Map related fields
  // Map center coordinates
  centerLat: number = 51.678418;
  centerLng: number = 7.809007;

  // Current distance from center (in meters)
  currentDistance: number = 1000;

  // Map zoom level
  zoom: number = 14;

  selectedStep:number = 1;


  // Update interval in milliseconds
  updateInterval: number = 5000;
  lookingForDriversSignal: Signal<boolean> = signal(false); 

  ticketDataToShow:any = null;

  updateZoomLevel() {
    // Calculate zoom level based on distance
    // This formula may need adjustment based on your specific needs
    this.zoom = Math.max(
      1,
      Math.min(20, 15 - Math.log2(this.currentDistance / 1000))
    );

    console.log(`Distance: ${this.currentDistance}m, New Zoom: ${this.zoom}`);
  }

  selectStep(step:number){
    this.lookingForDrivers=false;
    console.log('SELECT STEP ==> ', step);
    this.selectedStep = step;
    // console.log('LOUNGE STEPPER ==> ', this.loungeStepper.selectedIndex,' STEP ==> ', step);
    if (this.loungeStepper&& this.loungeStepper.selectedIndex != step) {
      this.loungeStepper.selectedIndex = step ;
    }

    

    // Mark for check
    this._changeDetectorRef.markForCheck();

  }


  selectedSecteurForm!: FormGroup;
  locationsSearch: FormControl = new FormControl('');
  departControl: FormControl = new FormControl('AÉROPORT MARRAKECH MÉNARA');
  locations: any = [];

  phoneNumber = new FormGroup({
    country: new FormControl('ma'),
    countryNumber: new FormControl('+212'),
  });

  displayNightText: boolean = false;
  activeLang: string = '';

  googleMode: boolean = false;

  currentTime = '';
  currentPlacement = '';

  qtySliderValue: number = 1;
  qtySliderPptions: Options = {
    showTicksValues: true,
    stepsArray: [
      // { value: 1 },
      // { value: 2 },
      // { value: 3 },
      // { value: 4 },
      // { value: 5 },
      // { value: 6 },
    ],
  };

  lggSliderValue: number = 1;
  lggSliderPptions: Options = {
    showTicksValues: true,
    stepsArray: [
      // { value: 1 },
      // { value: 2 },
      // { value: 3 },
      // { value: 4 },
      // { value: 5 },
      // { value: 6 },
      // { value: 7 },
      // { value: 8 },
    ],
  };

  showPayement:boolean = false;
  departFound: boolean = false;
  lat: number = 0;
  lng: number = 0;
  departTitle: string = '';

  currentRetailerId = '';

  extraOptions:any = null;
  // Le code saisi sous forme d'un tableau de 4 chiffres (strings)
  verificationCodeDigits: string[] = ['', '', '', ''];
  // Message d'erreur de vérification
  verificationError: string | null = null;

  

  // Contrôle du bouton de réenvoi
  canResend = false;
  resendCountdown = 30; // secondes avant de pouvoir renvoyer
  private countdownSubscription?: Subscription;

  // Indique si la vérification est en cours (pour désactiver le bouton)
  verifyingCode = false;

  animationState = 'initial';
  tokenBot: string = '';

  walletInfo: any = null;

  paymentModes: { id: number; label: string; icon?: string; class?: string }[] =
    [
      {
        id: 4,
        label: 'card',
        icon: 'mat_solid:money',
        class: ' text-green-500',
      },
      {
        id: 2,
        label: 'cash',
        icon: 'mat_solid:money',
        class: ' text-green-500',
      },
      {
        id: 3,
        label: 'wemoney',
        icon: 'mat_solid:account_balance_wallet',
        class: 'animate-pulse text-[#F8CB4D]',
      },
  ];

  /**
   * Constructor
   */
  constructor(
    private languageService: TranslationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _formBuilder: FormBuilder,
    private googleMapsService: GoogleMapsService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private clientService: ClientService,
    private chatbotService:ChatbotService,
    private _orderService: TaxisService,
    private adapter: DateAdapter<any>,
    private _router: Router,
    private route: ActivatedRoute,
    private _activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private _splashScreenService: FuseSplashScreenService,
    private walletService: WalletService,
    private translateService: TranslationService,
    // private denseLayoutComponent: DenseLayoutComponent,
    @Inject(DOCUMENT) private document:any,
     private _fuseConfirmationService: FuseConfirmationService,
    private _userservice: ClientService,
    private seoService:SeoService,
    private titleService: Title, private metaService: Meta,
    private sanitizer: DomSanitizer,
    private metaDataService: MetaDataService
    // private _translocoService: TranslocoService
  ) {

    this.initFomrs();
    this._splashScreenService.show();
    let activeLang = this.languageService.getCurrentLanguage();
    // moment.locale(activeLang); 
    this.adapter.setLocale(activeLang); // pour Angular Material


    //this.selectedSecteurForm.markAllAsTouched();

   

    this.isBrowser = isPlatformBrowser(this.platformId);

    this.billingForm = this._formBuilder.group({
      fname: [''],
      name: ['', [Validators.required]],
      middleName: '',
      //company: "",
      email: ['', [Validators.email]],
      phone: ['', [Validators.required]],
      //country: ["", ],
      city: [''],
      state: '',
      zip: [''],
      address: [''],
    });
 this._splashScreenService.show()
    this.paymentForm = this._formBuilder.group({
      cardHolderName: [''],
      cardNumber: [''],
      expiredDate: [''],
      clearExpiredDate: [''],
      //expiredYear: ["", ],
      cvv: [''],
    });

    //this.buildFormControl1();
    // this.calculateAllTTC();


  }

  get adultPassengersFormArray(): FormArray {
    return this.eventForm1.get('adultPassengers') as FormArray;
  }

  get childrenPassengersFormArray(): FormArray {
    return this.eventForm1.get('childrenPassengers') as FormArray;
  }

  get babiesPassengersFormArray(): FormArray {
    return this.eventForm1.get('babiesPassengers') as FormArray;
  }

  get country(): FormControl {
    return this.thirdStepForm.get('country') as FormControl;
  }


  get qtyControl(): FormControl {
  return this.secondStepForm.get('qty') as FormControl;
  }

  get phone(): FormControl {
    return this.thirdStepForm.get('phone') as FormControl;
  }

    // "Mini-moment" pour manipuler dates + fuseau
  myMoment = {
      startOfMonth: (date: Date) => {
    const d = new Date(date);
    d.setDate(1);
    d.setHours(0, 0, 0, 0);
    return d;
  },
    now: () => new Date(),
    
    addMinutes: (date: Date, minutes: number) => {
      return new Date(date.getTime() + minutes * 60 * 1000);
    },

    format: (date: Date, options?: Intl.DateTimeFormatOptions) => {
      return new Intl.DateTimeFormat(this.activeLang, {
        ...options
      }).format(date);
    },

    tz: (date: Date, timezone?: string) => {
      const tz = timezone || this.timezone;
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });
      const parts = formatter.formatToParts(date);
      const dateParts: any = {};
      parts.forEach(({ type, value }) => dateParts[type] = value);

      return new Date(
        `${dateParts.year}-${dateParts.month}-${dateParts.day}T${dateParts.hour}:${dateParts.minute}:${dateParts.second}`
      );
    }
  };

  gitex_retailer_setting:any = null;
  kech_retailer_setting:any= null;
  settings:any = null;
  isClient:any = false;
  isShowCitys:boolean = false;
  // Used when client is valid and wants to change the initial address to another tign besides gitex
  isNewInitial:any = false;
  validClient:any= null;
  lookingForDrivers:boolean = false;
  retailesObjects:any[]=[];
  departQueryParam:string='';

  selectedTypeSignal= signal(0);

  get firstStepForm(): FormGroup {
    return this.selectedSecteurForm.get('firstStepForm') as FormGroup;
  }
  get calculatePriceForm(): FormGroup {
    return this.selectedSecteurForm.get('calculatePriceForm') as FormGroup;
  }

  get secondStepForm(): FormGroup {
    return this.selectedSecteurForm.get('secondStepForm') as FormGroup;
  }

  get thirdStepForm():FormGroup{
    return this.selectedSecteurForm.get('thirdStepForm') as FormGroup;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  

  initFomrs(){
        this.selectedSecteurForm = this._formBuilder.group({
          firstStepForm: this._formBuilder.group({
            initial_place_id: [null, [Validators.required]],
            initialLat: [null, [Validators.required]],
            initialLng: [null, [Validators.required]],
            depart: [null, [Validators.required]],
            destination_place_id:[null, [Validators.required]],
            destinationLat: [null, [Validators.required]],
            destinationLng: [null, [Validators.required]],
            destination: [null, [Validators.required]],
            date: [this.getCurrentDate(), [Validators.required]],
            dateShow: [this.getCurrentDate(), [Validators.required]],
            time: [this.getCurrentTime(),[Validators.pattern('^(0[0-9]|1[0-9]|2[0-4]|[0-9]):([0-5][0-9])')]],

          }),

          calculatePriceForm: this._formBuilder.group({


                    tripType: [null,[Validators.required]],
                    price: [null,[Validators.required]],
                    isNight: [null,[Validators.required]],
                    distance: [null,[Validators.required]],
                    duration: [null,[Validators.required]],
                    type: [null,[Validators.required]],
                    outside: [null,[Validators.required]],
                    success: [null, [Validators.required, Validators.requiredTrue]], // Now requires true value
                    newCity: [null,[Validators.required]],
                    ht: [null,[Validators.required]],
                    tva: [null,[Validators.required]],
                    estimatedPrice: [null,[Validators.required]],
                    

                    validOptions: this._formBuilder.group({
                      maxPassengers: [null,[Validators.required]],
                      maxLuggage: [null,[Validators.required]]
                    }),
                    taxis: this._formBuilder.array([])
        }),

        secondStepForm: this._formBuilder.group({
                luggage: [1, [Validators.required]],
                isDog: [false, [Validators.required]],
                isSurf: [false, [Validators.required]],
                isGolf: [false, [Validators.required]],
                isBicycle: [false, [Validators.required]],
                isHandicapped: [false, [Validators.required]],
                isOldMedina: [false, [Validators.required]],
                forcedType: [0, [Validators.required]],  
                qty: [1, [Validators.required]],
        }),
        thirdStepForm: this._formBuilder.group({
          name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
          phone : ['', [Validators.required,Validators.pattern(/^\d{9,14}$/)]],
          country:[null,[Validators.required]]
        }),



          
      _id: [''],
      km: [''],
      date: [''],
      // depart: ['', [Validators.required]],
      destination: ['', [Validators.required]],
      time: [
        '',
        [Validators.pattern('^(0[0-9]|1[0-9]|2[0-4]|[0-9]):([0-5][0-9])')],
      ],
      title: ['Item', [Validators.required]],
      ht: [0, [Validators.required]],
      ttc: [0, [Validators.required]],
      tva: [0, [Validators.required]],
      price: [0, [Validators.required]],
      isNight: [false],
      qty: [1, [Validators.required]],
      type: [0, [Validators.required]],
      zoneId: [''],
      secteur: [''],
      lng: [''],
      lat: [''],
      place_id: [''],
      tz: [''],
      aller: [true],
      retour: [false],
      retourName: [''],
      retourPhone: ['', [Validators.pattern(/^\+[1-9]\d{9,14}$/)]],
      country: ['ma'],
      //
      driverId: [''],
      //
      affect: [false],
      //
      luggage: [1],
      isDog: [false],
      isSurf: [false],
      isGolf: [false],
      isBicycle: [false],
      isHandicapped: [false],
      isOldMedina: [false],
      //
      initialAddress: ['', [Validators.required]],
      initialLat: ['', [Validators.required]],
      initialLng: ['', [Validators.required]],
      initial_place_id: ['', [Validators.required]],
      destinationAddress: ['', [Validators.required]],
      destinationLat: ['', [Validators.required]],
      destinationLng: ['', [Validators.required]],
      destination_place_id: ['', [Validators.required]],
      distance: [0],
      duration: [0],
      paymentMode: [1, [Validators.required]],
      forcedType: [0, [Validators.required]],  
        });
         this.eventForm = this._formBuilder.group({
      _id: [''],
      packId: [1],
    });

    this.eventForm1 = this._formBuilder.group({
      _id: [''],

      retourName: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(/^[a-zA-ZÀ-ÿ\s'-]{2,}$/) 
      ]],

      retourPhone: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{6,15}$/) 
      ]],

      country: ['ma'],
      countryNumber: ['+212', [
        Validators.required,
        Validators.pattern(/^\+\d{1,4}$/)
      ]],
    });
       const now = new Date();

// Appliquer le fuseau horaire en créant une date locale pour ce fuseau
const timeZone = this.timezone;

// Obtenir l'heure dans le fuseau et convertir en ISO
// Méthode : on récupère l'heure locale du fuseau et on crée une Date ISO
const formatter = new Intl.DateTimeFormat('en-US', {
  timeZone,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const parts = formatter.formatToParts(now);
const dateObj: any = {};
parts.forEach(({ type, value }) => {
  dateObj[type] = value;
});

// Créer une date ISO (YYYY-MM-DDTHH:mm:ss)
const isoDate = `${dateObj.year}-${dateObj.month}-${dateObj.day}T${dateObj.hour}:${dateObj.minute}:${dateObj.second}`;

// Mettre à jour le formulaire
this.selectedSecteurForm.get('date')?.setValue(isoDate);


  }

  seoContent:any = null;


  resetForms() {
  this.firstStepForm.reset({date: this.getCurrentDate(), dateShow: this.getCurrentDate(), time: this.getCurrentTime()});
  this.secondStepForm.reset({luggage: 1, isDog: false, isSurf: false, isGolf: false, isBicycle: false, isHandicapped: false, isOldMedina: false, forcedType: 0, qty: 1});
  this.thirdStepForm.reset({});
  this.calculatePriceForm.reset({});

  this.eventForm.reset({
    _id: '',
    packId: 1,
  });

  this.eventForm1.reset({
    _id: '',
    retourName: '',
    retourPhone: '',
    country: 'ma',
    countryNumber: '+212',
  });



}

selectPriceType(type:number,taxis:any):number{
  console.log('SELECT PRICE TYPE ==> ', type, taxis);
  let selectedType= taxis.filter((t: any) => t.taxiType == type)
  console.log('SELECTED TYPE ==> ', selectedType);

  return selectedType[0].price
}

buildCalculePriceForm(data?: any): void {
   if (!this.firstStepForm) return;
   console.log('BUILD CALCULE PRICE FORM ==> ', data);
   if(data.taxis && Array.isArray(data?.taxis)&& data?.taxis.length==1){
     data.forcedType= data?.taxis[0]?.typeTaxi;
   }
   let type = data?.forcedType >0 ? data?.forcedType : data?.type;


  this.calculatePriceForm.patchValue({
    tripType: data?.tripType ?? null,
    price:  this.selectPriceType(type, data?.taxis) ?? null,
    isNight: data?.isNight ?? null,
    distance: data?.distance ?? null,
    duration: data?.duration ?? null,
    outside: data?.outside ?? null,
    success: data?.success ?? null,
    newCity: data?.newCity ?? null,
    ht: data?.ht ?? null,
    tva: data?.tva ?? null,
    estimatedPrice: data?.estimatedPrice ?? null,

    validOptions: {
      maxPassengers: data?.validOptions?.maxPassengers ?? null,
      maxLuggage: data?.validOptions?.maxLuggage ?? null
    }

  });
  const vehicsArray = this.calculatePriceForm.get('taxis') as FormArray;
  vehicsArray.clear();
  console.log('AVAILABLE VEHICS ==> ', data?.taxis);

  if (Array.isArray(data?.taxis)&& data?.taxis.length>1 &&(this.secondStepForm.get('qty')?.value <= 3 && this.secondStepForm.get('luggage')?.value <= 3)) {
    data.taxis.forEach((vehic: any) => {
      vehicsArray.push(
        this._formBuilder.group({
          id: [vehic?.typeTaxi ?? null],
          title: [vehic?.title ?? null]
         
        })
      );
    });
  this.calculatePriceForm.get('type')?.setValue(data?.type ?? null,{emitEvent: false});
   
  }else       this.calculatePriceForm.get('type')?.setValue(data?.type ?? null); 


   

}
        
  cityPlaceIds: any = {
            1: "Xsw4ZD3k",  // Marrakech
            2: "Asw4nbxY",  // Casablanca
            3: "g9KvPn7e",  // Tanger
            4: "Y443dvas",   // Agadir
            5: "mpOM27oVxx"   // rabat
          }


  /**
   * On init
   */

  url: string = '';
  dataSeo:any = null;
  setMetaData(title:any,des:string,keys:string) {
    // Set the Title
    this.titleService.setTitle(title);

    // Update the Meta Description
    this.metaService.updateTag({ name: 'description', content: des });

    // Update the Meta Keywords
    this.metaService.updateTag({ name: 'keywords', content:keys});
  }
  randomTextHtml:SafeHtml='';
  cityName:string='';
  async ngOnInit(): Promise<void> {
    try {

    this._splashScreenService.show()
     this.url = this.route.snapshot.paramMap.get('url') || ''; 
    //  let retailerId= this._activatedRoute.snapshot.queryParams['d'] || '';
    //  if(retailerId){
    //     await this.selectedRetailer({value:retailerId})
    //  }
     
     await this.metaDataService.setMetaData('fr')
     this.cityName = this.route.snapshot.paramMap.get('cityName') || '';

     if(this.cityName && this.cityName.length>2){

      this.cityId= CityEnum[this.cityName.toUpperCase() as keyof typeof CityEnum];
      if(this.cityId){
        console.log('CITY ID FROM URL ==> ', this.cityId);
        this.isShowCitys=true;
      }
     }


    

     if(this.url){
      try {
    
     let data = await firstValueFrom(this.seoService.getSeoContentByUrl(this.url))

     
    if(!data) return 
    this.dataSeo=data
    if(isPlatformBrowser(this.platformId))  this.selectLanguage(this.dataSeo.lang || 'en')

    this.setMetaData(this.dataSeo.title,this.dataSeo.description,this.dataSeo.keyword)
    // this.dataSeo.h1=this.url?.replace(/-/g, ' ') || ''
    this.dataSeo.paragraph=this.dataSeo.paragraph.replace(/##./g, '')

        // Génère le HTML (liste d'anchors) et transforme en SafeHtml
    const html = this.createHtmlFromRandomText(this.dataSeo.randomText);
    this.randomTextHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        if(this.dataSeo && this.dataSeo.city){
      
      let citySeo= this.dataSeo.city;

          if(this.cityPlaceIds[citySeo]){
            console.log('Initial address set to city from SEO data', citySeo)
            await this.selectedRetailer({value:this.cityPlaceIds[citySeo]})
          }
    }
  }catch (error) {
    console.error('Error fetching SEO content:', error);
  }

     }
     else {
      let lang=  this.languageService.getCurrentLanguage()

      this.departQueryParam = this._activatedRoute.snapshot.queryParams['d'] || '';

      try {

        let data:any;

      if(this.departQueryParam){
            this.retailesObjects= await firstValueFrom(this._orderService.getRetailers());
            console.log('RETAILERS OBJECTS  V4 V6 ==> ', this.retailesObjects);
        let filteredRetailers = this.retailesObjects.filter((item:any) => item.onlineTitle==this.departQueryParam);
        let cityNumber= this.getNumberByRetailId(filteredRetailers[0].retailerId);
        // alert('CITY NUMBER DETECTED '+cityNumber)
        if(cityNumber)
         data = await firstValueFrom(this.seoService.findByWeight(1,lang,cityNumber));
        else
         data = await firstValueFrom(this.seoService.findByWeight(1,lang));
      }else {
         data = await firstValueFrom(this.seoService.findByWeight(1,lang));

      }
      console.log('SEO DATA BY WEIGHT ==> ', data);

      if(!data) return;
      // Génère le HTML (liste d'anchors) et transforme en SafeHtml
      const html = this.createHtmlFromRandomText(data);
      this.randomTextHtml = this.sanitizer.bypassSecurityTrustHtml(html);
      this.translateService.onTranslationChange(async (lang) => {
        console.log('Language changed to:', lang);
        if(this.departQueryParam){
  let filteredRetailers = this.retailesObjects.filter((item:any) => item.onlineTitle==this.departQueryParam);
        let cityNumber= this.getNumberByRetailId(filteredRetailers[0].retailerId);
         if(cityNumber)
         data = await firstValueFrom(this.seoService.findByWeight(1,lang,cityNumber));
        else
         data = await firstValueFrom(this.seoService.findByWeight(1,lang));
        }else {
         data = await firstValueFrom(this.seoService.findByWeight(1,lang));
        }
        if(!data) return;
        const html = this.createHtmlFromRandomText(data);
        this.randomTextHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        this._changeDetectorRef.markForCheck();

      });
     }
    catch (error) {
      console.error('Error fetching SEO content:', error);
    }
  }

    console.log('CURRENT URL ==> ', this.url);
    let path= this._router.url;
    console.log("CURRENT PATH ==> ",path);
        console.log("CURRENT PATH ==> ",path)
    if(path.includes('/fr')) {

    await this.metaDataService.setMetaData('fr')      
    }else if(path.includes('/en')) {
      await this.metaDataService.setMetaData('en')      
    } else if(path.includes('/ar')) {
      await this.metaDataService.setMetaData('ar')      
    }

    this.calculatePriceForm.get('type')?.valueChanges
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe((value) => {
      console.log('SELECTED TYPE CHANGED ==> ', value);
      if(value===null) return;
      // if(this.selectedSecteurForm.get('forcedType')?.value==0) return;
      this.selectedTypeSignal.set(value);
      if(!this.selectedSecteur || !this.selectedSecteur.taxiTypes || value === 0) return;
      let typeTaxi = this.selectedSecteur.taxiTypes.filter((item:any) => item.id === value)[0];
      let qty = this.secondStepForm.get('qty')?.value || 1;
      let luggage = this.secondStepForm.get('luggage')?.value || 1;

      if(qty> typeTaxi.maxPassengers){
       this.secondStepForm.get('qty')?.setValue(typeTaxi.maxPassengers);
      }
      if(luggage > typeTaxi.maxLuggage){
       this.secondStepForm.get('luggage')?.setValue(typeTaxi.maxLuggage);
      }


    // this.secondStepForm.patchValue({ forcedType: this.selectedTypeSignal()});

    });



    this.firstStepForm.valueChanges
    .pipe(takeUntil(this._unsubscribeAll),   
         distinctUntilChanged((prev, curr) => {
      const prevFiltered = { ...prev, depart: null, destination: null, dateShow: null };
      const currFiltered = { ...curr, depart: null, destination: null, dateShow: null };

      return JSON.stringify(prevFiltered) === JSON.stringify(currFiltered);
    })
   )
    .subscribe((changes) => {
      console.log('FIRST STEP FORM CHANGES ==> ', changes);
      if(this.firstStepForm.valid) {
        this.updatePrice();
      }
      
    });

    this.ticketId = this._activatedRoute.snapshot.queryParams['ticketId'] || '';
    this.status = this._activatedRoute.snapshot.queryParams['status'] || '';
    this.isShowTicket = this._activatedRoute.snapshot.queryParams['isShowTicket'] == 'true' || false;
    console.log("DEPART QUERY PARAM ==> ", this.departQueryParam);
    console.log('TICKET ID & STATUS ==> ', this.ticketId);
    console.log('PARAM MAP ==> ',this._activatedRoute.snapshot)


    console.log('CURRENT DOMAIN ==> ', this.document?.location?.hostname);
    this.currentLang= this.languageService.getCurrentLanguage()
            console.log("CURRENT LANGUAGE ==> ", this.currentLang)
    let iframeToken =  this._activatedRoute.snapshot.queryParams['iframeToken'] || '';
    this.iframeToken = iframeToken;
    this.tokenBot= this._activatedRoute.snapshot.queryParams['token'] || '';

    console.log('iframe mode activated ',iframeToken)
    this._changeDetectorRef.markForCheck();
    if (isPlatformBrowser(this.platformId)) {
          let path= this._router.url;
    console.log("CURRENT PATH ==> ",path)
    if(path.includes('/fr')) {

      this.selectLanguage('fr');
      
    }else if(path.includes('/en')) {
      this.selectLanguage('en');
    } else if(path.includes('/ar')) {
      this.selectLanguage('ar');
    }



      if(this.iframeToken==environment.tokenIfram){

        console.log('IFRAME TOKEN DETECTED ==> ', this.iframeToken);

              const token=this._activatedRoute.snapshot.queryParams['tokenBearer'] || '';
              localStorage.setItem("clientToken",token)
                     this._changeDetectorRef.markForCheck();


      }
      if(this.tokenBot && this.tokenBot.length>10){

      let res= await firstValueFrom(this.chatbotService.validePaymentCMI(this.tokenBot,this.ticketId)) as any;

      if(res.success){

        window.location.href='https://wa.me/212636271341'

      }

      



      }




             

      console.log("isShowTicket",this.isShowTicket)

          if(this.isShowTicket ||  path.includes('ticket-confirmation')) {
            this._splashScreenService.show();
            const ticketId = path.split('?')[0].split('/').pop();
            console.log(ticketId); 
            this.ticketId= ticketId || '';
          
           
          let trip= await firstValueFrom(this._orderService.fetchPopularTrip(ticketId));


          if(trip && trip.success!=false) {
          this.tripType = trip.ticket.tripType;
          this.ticketData = trip.ticket;
          this.lookingForDrivers= true;
          this.isShowTicket= true;
          
          // if(this.tripType==1){
          //   this._router.navigate(['ticket-confirmation', this.ticketId], { relativeTo: this.route });
          // } else if(!this.isNotifyingDrivers || this.isShowTicket) {
          //   this._router.navigate(['ticket-confirmation-trip', this.ticketId], { relativeTo: this.route, queryParams: {showTicket:this.isShowTicket, notifyDriver:true, downloadTicket:false} });
          // }
           return;
          }
          else {
            // this._splashScreenService.hide();

            // alert('Trip not found');
            this.openDialog(this.languageService.translateKey('ERRORS.TRIP_NOT_FOUND'), this.languageService.translateKey('ERRORS.TRIP_NOT_FOUND_DESCRIPTION'), this.successIcon);
            // return;
          }

          }
      this.token = localStorage.getItem('clientToken') || '';
      console.log('QUERY PARAMS TOKEN --> ', this.token);
      this.socket = socketClusterClient.create({
        hostname: environment.socketUrl,
        secure: environment.secure,
        port: environment.port,
        autoReconnect: true,
        autoReconnectOptions: {
          initialDelay: 1000,
          multiplier: 1,
          maxDelay: 1000,
        },
      });
      if( this.token ){
      let validClient = await lastValueFrom(
            this._orderService.checkClientToken()
           );
        if (validClient.success) {
              this.validClient = validClient?.data ?? null;
              this.isClient = true;
              this.validClient = validClient?.data ?? null;
              this.isClient = true;
              this.fetchWalletInfo();
              this.clearPhoneValidators();
              // this.currentTripModeSignal=0;


              this.listenToDriversBroadcast(this.socket,this.validClient.userId);
              this.listenToWalletBroadcast(this.socket,this.validClient.userId);
              }else {
              this.token = '';
              }

      }

          if(this.ticketId && this.status && this.token) {  
          localStorage.setItem('currentTicketId', this.ticketId);

            
            

            console.log('TICKET ID & STATUS FOUND --> ', this.ticketId, this.status);
            // this.token = localStorage.getItem('clientToken') || '';

            this._splashScreenService.hide();
            console.log("loungeStepper",this.loungeStepper);
            this._changeDetectorRef.markForCheck();
            this._changeDetectorRef.detectChanges();

            console.log("lookingForDrivers",this.lookingForDrivers)
            console.log('VALID CLIENT ==> ', this.validClient);
          //   let validClient = await lastValueFrom(
          //   this._orderService.checkClientToken()
          //  );
            // console.log('VALID CLIENT ==> ', validClient);
            // if (validClient.success) {
            //   this.validClient = validClient?.data ?? null;
            //   this.isClient = true;
              // this.currentTripModeSignal=0;


              // this.listenToDriversBroadcast(this.socket, this.validClient.userId);

              // this.listenToTripSocket(this.validClient?.userId, this.ticketId);
              // this.listenToTripSocketAccepted(this.validClient?.userId, this.ticketId)
              try {

                let trip= await lastValueFrom(this._orderService.fetchPopularTrip(this.ticketId));
                if((trip.success!=undefined) && !trip.success){
                     const title = this.languageService.translateKey('ERRORS.TITLE')
                       const message = this.languageService.translateKey('ERRORS.TRIP_NOT_FOUND');
                    this.openDialog(title, message, this.successIcon);
                } else {
                console.log('TRIP RES  type ==> ', trip.ticket.tripType);
                const resNotif= await lastValueFrom(this.clientService.notifyDrivers(this.ticketId));
                if(resNotif && resNotif.success){
                    this.tripType = trip.ticket.tripType;
                    this.ticketData = trip.ticket;
                    this.lookingForDrivers= true;
                    // alert('Trip found, waiting for drivers to accept..onInit.');
                    
                    if(this.tripType!=1){
                    this.listenToTripSocketAccepted(this.validClient?.userId, this.ticketId);
                    // const resNotif= await lastValueFrom(this.clientService.notifyDrivers(this.ticketId));
                    // console.log('NOTIFY DRIVERS RESPONSE ==> ', resNotif);
                }
                else {
               this._router.navigate(['ticket-confirmation', this.ticketId], { relativeTo: this.route });
                }
                }

               
                return;
                }
                

              } catch (error) {
                console.error('Error notifying drivers:', error);

              }
              

            
              this._changeDetectorRef.detectChanges();
            

          }


        try {
                    this._splashScreenService.hide();


        //! When Depart is changed in the app-agm-map we update values in this form directly
    this.departureControl.valueChanges.subscribe(
      async (value: {
        place_id: string;
        lat: number;
        lng: number;
        address: string;
      }) => {
        console.log('DEPARTURE CONTROL VALUE CHANGED ==> ', value);

        this.firstStepForm.patchValue({
          initialLat: value.lat,
          initialLng: value.lng,
          initial_place_id: value.place_id,
          depart:  value.address,
        });
        this.firstStepForm.updateValueAndValidity();
        if (value) {
          await this.chargeDepartByPlaceId(value);
        }
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }
    );

    //! When Destination is changed in the app-agm-map we update values in this form directly
    this.arriveControl.valueChanges.subscribe(
      async (value: {
        place_id: string;
        lat: number;
        lng: number;
        address: string;
      }) => {
        console.log('ARRIVEE CONTROL VALUE CHANGED ==> ', value);

        this.firstStepForm.patchValue({
          destinationAddress: value.address,
          destinationLat: value.lat,
          destinationLng: value.lng,
          destination_place_id: value.place_id,
          destination:  value.address,
        });

        this.firstStepForm.updateValueAndValidity();

        if (value) {
          await this.chargeDestinationsByPlaceId(value);
        }
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }
    );

    this._splashScreenService.hide();

    // Mark for check
          // Récupérer les données sauvegardées
          const savedTripData = localStorage.getItem('pendingTripData');
          if (savedTripData) {
            const tripData = JSON.parse(savedTripData);         
          // this.fetchWalletInfo()
          this.loungeStepper.selectedIndex = 2;
          
          return;
        }
      } catch (error) {
        console.error('Error restoring form data:', error);
      }
    }

    // if(this.ticketId && this.status) return;
    console.log('CURRENT TZ ==> ', this.timezone);
    //! We first check if there is token is in query param
    //! If so we set  clientMode true, meaning we remove retourName & retourPhone
    //! Display payment modes option, cash or wemoney
    let queryParamsObj = this._activatedRoute.snapshot.queryParams;
    console.log('QUERY PARAMS OBJ --> ', queryParamsObj);
    this.isLoading = true;
    // let localStorage:any;
    // let token = localStorage.getItem('clientToken-1');

    //! Make sure the token is valid and belongs to a client, if so we fetch his info so it's used
    //! Also give choise to select another initial besides gitex
    //! Also use settings of kech instead of gitex
    if (this.token) {
      // localStorage.setItem('token', token);

    // let validClient = await lastValueFrom(
    //     this._orderService.checkClientToken()
    // );
    // console.log('VALID CLIENT ==> ', validClient);
    // if (validClient.success) {
      
    //     // this.isClient=false;
    //     // await this.executeDepartLogic('kech');
    //   } else {
    //     // localStorage.setItem('token', '');
    //     this.token = '';
    //     // await this.executeDepartLogic('kech');
    //   }
    }
    //! if not token we strictly only use from gitex to another place
    else {
      // localStorage.setItem('token', '');
      // await this.executeDepartLogic('kech');
    }
    console.log('IS CLIENT ??? --> ', this.isClient);
    this.isLoading = false;
    //  if (departValue) {

    //    }

    // Get the country telephone codes


    // Get the country telephone codes
    this._orderService.countries$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((codes: any) => {
        this.countries = codes;
        this.filteredCountries = codes;
        console.log('COUNTRIES RESPONSE ==> ', codes);
        // console.log('COUNTRIES ==> ', codes);
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
    this._orderService.getCountries().subscribe();
    // Get the country telephone codes
    this._orderService.returnToStep1$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        console.log('SUBSCRIBE RETURN TO STEP1 --> ', res);
        if (typeof res === 'boolean' && res === true) {
          this.returnToStepOne();
        }

        // Mark for check
        this._changeDetectorRef.markForCheck();
      });

    this._orderService.popularSecteurs$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        console.log('SUBSCRIBE POPULAR SECTEURS ==> ', response);
        this.popularSecteurs = response;
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });

    this.phoneNumber.get('country')?.valueChanges.subscribe((val:any) => {
      console.log('COUNTRY VAL CHANGE ===> ', val);
      this.eventForm1.get('country')?.setValue(val);
      let isoNumber = this.getCountryByCode(val)?.code ?? '+212';
      this.eventForm1.get('countryNumber')?.setValue(isoNumber);
      this.eventForm1.updateValueAndValidity();
    });
     this.secondStepForm.get('luggage')?.valueChanges     
     .subscribe((val:any) => {
      console.log('LUGGAGE VALUE CHANGED ==> ', this.luggageControl.value); 
      // if( val < 1 ) return;
        console.log('luggage VALUE CHANGED ==> ', val);
        if(!this.selectedSecteur||!this.selectedSecteur.taxiTypes || this.selectedTypeSignal()==0) return;
        console.log('selectedTypeSignal in update qty', this.selectedTypeSignal());
        let typeTaxi= this.selectedSecteur.taxiTypes.filter((item:any) => item.id === this.selectedTypeSignal())[0];
        if(typeTaxi==undefined) return;
        console.log('TYPE TAXI ==> ', typeTaxi,' VAL ==> ', val );
        if( val>typeTaxi.maxLuggage){
          this.selectedTypeSignal.set(typeTaxi.id=== 1 ? 2 : 1);
          this.secondStepForm.patchValue({ forcedType: this.selectedTypeSignal()});
        console.log('selectedTypeSignal in update qty after', this.selectedTypeSignal());
        }

      // this.updatePrice();

     })


    this.secondStepForm.get('qty')?.valueChanges
      // .pipe(debounceTime(500))
      .subscribe((val:any) => {
        
        console.log('QTY VALUE CHANGED ==> ', val);
        if(!this.selectedSecteur||!this.selectedSecteur.taxiTypes || this.selectedTypeSignal()==0) return;
        console.log('selectedTypeSignal in update qty', this.selectedTypeSignal());
        let typeTaxi= this.selectedSecteur.taxiTypes.filter((item:any) => item.id === this.selectedTypeSignal())[0];
        console.log('TYPE TAXI ==> ', typeTaxi,' VAL ==> ', val );
                if(typeTaxi==undefined) return;

        if( val>typeTaxi.maxPassengers){
          this.selectedTypeSignal.set(typeTaxi.id=== 1 ? 2 : 1);
          this.secondStepForm.patchValue({ forcedType: this.selectedTypeSignal()});

        console.log('selectedTypeSignal in update qty after', this.selectedTypeSignal());
        }

        // this.updatePrice();
      });
    // Get the board
    this._orderService.secteurs$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((response: any) => {
        console.log('SUBSCRIBE SECTEURS RESPONSE ==> ', response);

        if (Array.isArray(response) && !response?.length) {
          //if (!this.googleMode) {this.selectedSecteurForm.get('luggage')
          //this.googleMode = true;
          console.log('TOGGLE GOOGLE MODE ==> ');
          this.getAutocompletePredictions(
            this.selectedSecteurForm.get('destination')?.value ?? ''
          );
          //  }
          this.googleMode = true;
        } else {
          this.googleMode = false;
          this.locations = response;
        }

        // if (!this.googleMode && response) {
        //   if (!response?.length) {
        //     this.googleMode = true;
        //     // this.selectedSecteurForm.get('destination').setValidators([]);
        //     // this.selectedSecteurForm.get('destination').reset();
        //     // this.selectedSecteurForm.updateValueAndValidity();
        //     this.locations = [];
        //     this.getAutocompletePredictions(
        //       this.selectedSecteurForm.get('destination').value ?? ''
        //     );
        //   }

        //   this.locations = response;
        // }

        // Mark for check
        this._changeDetectorRef.markForCheck();
      });

    this.googleMode = false;


    if(this.loungeStepper)this.loungeStepper.selectionChange.pipe(
      takeUntil(this._unsubscribeAll)).subscribe((value) => {

        console.log('LOUNGE STEPPER SELECTION CHANGE --> ', value);
        // console.log('LOUNGE STEPPER CHANGE --> ', value);
      });
    // // Subscribe to language changes
    // this._translocoService.langChanges$.subscribe((activeLang) => {
    //   // Get the active lang
    //   this.activeLang = activeLang;
    //   localStorage.setItem('taxilo_dflt_lng', activeLang);
    // });

    // this._splashScreenService.hide();
  }catch(error){
    console.error('Error in ngOnInit:', error);
    // this._splashScreenService.hide();
  }

  }
    private createHtmlFromRandomText(list: Array<{url: string, text: string}>): string {
    if (!Array.isArray(list) || list.length === 0) return '';
    // Exemple : une grille de liens responsive
    const items = list.map(item =>
  `<a class="seo-link" href="/${this.escapeHtml(item.url)}" title="${this.escapeHtml(item.text)}">
     ${this.escapeHtml(item.text)}
   </a>`
);

return `
  <div class="seo-links">
    ${items.join('')}
  </div>
`;

  }

  // Petite fonction d'échappement pour éviter injection via les textes (URL + texte affiché)
  private escapeHtml(str: string): string {
    if (!str) return '';
    return str.replace(/[&<>"'`=\/]/g, s => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;','/':'&#x2F;','`':'&#x60;','=':'&#x3D;'
    } as any)[s]);
  }
  //   async chargeDestinationsByPlaceId(placeId:string) {

  //    let res= await this.getLatLngFromPlaceId(placeId)
  //    let destination = await transformPlaceData(res);

  //    console.log('RES FROM PLACE ID ==> ', destination);
  //    let event:any = { option: { value: destination } };
  //   //  this.retailesObjects = [];
  //    this.selectedLocation(event, 2);

  progressBar = signal({
    name: 'Réponse au trajet',
    secondsLeft: 30,
    progress: 100
  });

  interval: any;  
  /**
   * Listen to drivers broadcast in realtime
   * @param socket SocketClientCluster Object
   * @param userId User's identifier
   * @param ticketId The trip ticket Id
   * @returns
   */
  listenToDriversBroadcast(
    socket: socketClusterClient.AGClientSocket | null,
    userId: string,
  ) {
    console.log('LISTEN TO DRIVERS BROADCAST ==> ', socket, userId);
    if (!socket || !userId ) {
      return;
    }
    this.driversNotify= [];
    (async () => {
      const myChannel = this.socket?.subscribe(
        'client-trip-broadcast-' + userId
      );
      (async () => {
        this.driversNotify= [];

        console.log('LISTENING TO DRIVERS BROADCAST CHANNEL ==> ', myChannel);
        console.log('driversNotify ==> ', this.driversNotify);
        // alert('Listening to drivers broadcast...');
        for await (let data of myChannel as any) {
          console.log('REALTIME TRIP BROADCAST MESSAGE => ', data);
        if(!this.lookingForDrivers){
          this.driversNotify = [];
          console.log('NOTIFYING DRIVERS IS FALSE, RETURNING');
         
        }else{
          if(data.mode!=3){
             this.currentTripModeSignal.set((data.mode));
             this._changeDetectorRef.markForCheck();
          }
        console.log('DRIVERS NOTIFY  befor bush ==> ', this.driversNotify);

        if(data.mode==1 && data.data && data.data.length>0) {
          this.driversNotify.push(...data.data);
          this._changeDetectorRef.markForCheck();

        }
        console.log('DRIVERS NOTIFY ==> ', this.driversNotify);
        console.log('CURRENT TRIP MODE SIGNAL ==> ', this.currentTripModeSignal());
        }

      }
    })();
    })();
  }
   listenToWalletBroadcast(
    socket: socketClusterClient.AGClientSocket | null,
    userId: string,
  ){
        console.log('LISTEN TO DRIVERS BROADCAST ==> ', socket, userId);
    if (!socket || !userId ) {
      return;
    }
    this.driversNotify= [];
    (async () => {
      const myChannel = this.socket?.subscribe(
        'driver-wallet-' + userId
      );
      (async () => {
        this.driversNotify= [];

        console.log('LISTENING TO DRIVERS BROADCAST CHANNEL ==> ', myChannel);
        console.log('driversNotify ==> ', this.driversNotify);
        // alert('Listening to drivers broadcast...');
        for await (let data of myChannel as any) {
          console.log('REALTIME WALLET BROADCAST MESSAGE => ', data);
        await  this.fetchWalletInfo();

      }
    })();
    })();

  }

    async cancelTrip(tripId: any): Promise<void> {
    const dialogRef = this.dialog.open(TripCancellationDialogComponent, {
      width: '400px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._orderService.cancelTrip(tripId, result.reason).subscribe({
          next: async () => {
            this.driversNotify = [];
            this.retour();
          },
          error: (error: any) => {
            console.error('Error cancelling trip:', error);
          }
        });
      }
    });
  }
  async cancelTripInTimeOut(tripId: any): Promise<void> {
    const title = 'Trip Canceled';
    const message = 'The trip has been canceled.';

      this._orderService.cancelTrip(tripId).subscribe({
          next: async () => {
          this.openDialogINtiemOut(title, message, this.infoIcon,true,() => {
            console.log('Trip canceled dialog closed');
          // window.location.replace(window.location.origin + window.location.pathname);
                    this.retour()

          })
          
          // await this._router.navigate(['/trip']);
          },
          error: (error: any) => {
          console.error('Error cancelling trip:', error);
          }
          });
      
  }
  // }
  getLatLngFromPlaceId(placeId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // Create a dummy div (hidden)
      const dummyDiv = document.createElement('div');

      // Create a dummy map (not displayed)
      const map = new google.maps.Map(dummyDiv);

      const service = new google.maps.places.PlacesService(map);

      service.getDetails({ placeId: placeId }, async (place:any, status:any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place.geometry) {
          const location = place.geometry.location;
          console.log('LOCATION FROM PLACE ID ==> ', place);
          resolve(place);
        } else {
          reject(`Failed to fetch location for placeId: ${placeId} — Status: ${status}`);
        }
      });
    });
  }
 splitAndRemoveLastTwo(address: string): string {
  const parts = address.split(',').map(p => p.trim());

  if (parts.length <= 2) return parts[0]; // Rien à garder

  return parts.slice(0, -2).join(', ');
}
  
  async chargeDestinationsByPlaceId(placeId: any) {
    // let res = await this.getLatLngFromPlaceId(placeId);
    // let destination = await transformPlaceData(res);

    // console.log('RES FROM PLACE ID ==> ', destination);
    // let event = { option: { value: destination } };
    //  this.retailesObjects = [];
    console.log('CHARGE DESTINATION BY PLACE ID ==> ', placeId);
    this.selectedLocation(event, 2, true);
  }

  async chargeDepartByPlaceId(placeId: any) {
    // let res = await this.getLatLngFromPlaceId(placeId);
    // let destination = await transformPlaceData(res);

    // console.log('RES FROM PLACE ID ==> ', destination);
    // let event = { option: { value: destination } };
    //  this.retailesObjects = [];
    console.log('CHARGE DEPART BY PLACE ID ==> ', placeId);
    this.selectedLocation(event, 1, true);
  }


  getCurrentTime(){
    const now = new Date();
    const newDate = new Date(now.getTime() + 30 * 60 * 1000); // +30 minutes

    const currentTime = new Intl.DateTimeFormat('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: this.timezone
    }).format(newDate);

    console.log(currentTime);
    this.currentTime = currentTime;
    let currentHour = parseInt(currentTime.split(':')[0], 10);
    let currentMinutes = parseInt(currentTime.split(':')[1], 10);
    // Ajoute 10 minutes
    currentMinutes += 10;
    if (currentMinutes >= 60) {
      currentMinutes -= 60;
      currentHour += 1;
    }
    if (currentHour >= 24) {
      currentHour = 0;
    }
    // Met à jour le champ time avec le nouvel horaire (optionnel)
    const updatedTime = `${currentHour.toString().padStart(2, '0')}:${currentMinutes.toString().padStart(2, '0')}`;
   return updatedTime;
  }

getCurrentDate() {
  const tzDate = this.myMoment.tz(new Date());

  if (!(tzDate instanceof Date) || isNaN(tzDate.getTime())) {
    console.error("Invalid date returned by tz()");
    return new Date().toISOString();
  }

  return tzDate.toISOString();
}

   async selectedLocation(
    event: any,
    target: 1 | 2 = 2,
    skipCalcul = false
  ): Promise<void> {
    let value = event?.option?.value;

    console.log('SELECTED LOCATION VALUE ==> ', value);
    console.log('SELECTED LOCATION MODE ==> ', target);
    console.log('SELECTED LOCATION SKIP ==> ', skipCalcul);
    console.log('GOOGLE MODE --> ', this.googleMode);

    if (value?.onlineTitle) {
      this.executeDepartLogic(value.onlineTitle);

      return;
    }

    if (!skipCalcul) {
      let form = this.firstStepForm.getRawValue();
      console.log('FORM --> ', form);

      const geocoder = new google.maps.Geocoder();
      let zoneName = '';
      let city = '';
      let locality = '';
      let place_id = value.place_id;

      let { lat, lng }: any = await new Promise(async (resolve) => {
        geocoder.geocode(
          { placeId: value.place_id, region: 'ma' },
          async function (results: any, status: any) {
            if (status == 'OK') {
              console.log('RESULTS ==> ', results);
              let result = results[0];
              let lat = results[0]?.geometry?.location?.lat() ?? 0;
              let lng = results[0]?.geometry?.location?.lng() ?? 0;
              console.log('LAT LONG ==> ', { lat, lng });
              console.log('RESULT ====> ', result);

              place_id = result.place_id;

              resolve({ lat, lng });
            } else {
              alert(
                'Geocode was not successful for the following reason: ' + status
              );
              resolve({ lat: 0, lng: 0 });
            }
          }
        );
      });

      console.log('RESOLVED LAT LNG ===> ', { lat, lng });

      if (!lat || !lng) {
        return;
      }

      // alert(value.description)

      //! Make sure destination fields are full before proceeding
      if (target === 1) {
        console.log('TARGET 1', value);
        this.firstStepForm.patchValue({
          initial_place_id: place_id,
          initialLat: lat,
          initialLng: lng,
          depart: this.splitAndRemoveLastTwo( value.description)  ?? '',
        });
        if (
          !form?.destination_place_id ||
          !form?.destinationLat ||
          !form?.destinationLng
        ) {
          return;
        }
      }
      //! Make sure destination fields are full before proceeding
      else if (target === 2) {
        console.log('TARGET 2', value);
        this.firstStepForm.patchValue({
          destination_place_id: place_id,
          destinationLat: lat,
          destinationLng: lng,
          destination: this.splitAndRemoveLastTwo( value.description ?? value.title ?? ''),
        });
        if (!form?.initial_place_id || !form?.initialLat || !form?.initialLng) {
          return;
        }
      }
    }

    if (!skipCalcul) {
      let form = this.firstStepForm.getRawValue();
      if (target === 1) {
        this._orderService.updateDepartureData({
          initial_place_id: form.initial_place_id,
          initialLat: form.initialLat,
          initialLng: form.initialLng,
          initialAddress: form.depart,
        });
      } else if (target === 2) {
        this._orderService.updateDestinationData({
          destination_place_id: form.destination_place_id,
          destinationLat: form.destinationLat,
          destinationLng: form.destinationLng,
          destinationAddress: form.destination,
        });
      }
    }

    // await this.updatePrice();

    console.log(
      'SELECTED SECTEUR FORM VAL ==> ',
      this.firstStepForm.getRawValue()
    );

    // Mark for check
    this._changeDetectorRef.markForCheck();
  }
  onStepChanged(event: any) {
    console.log('STEP CHANGE --> ', event);
    this.lookingForDrivers=false;
    console.log('SELECT STEP ==> ', event.selectedIndex);
    this.selectedStep = event.selectedIndex;
    // this.selectStep(event.selectedIndex);

    if(event.selectedIndex === 0) {
        this.isInStepOne = true;
    }
    else this.isInStepOne = false;

    if (event.selectedIndex === 1) {


      // Add style targeting mat-horizontal-content-container
      // Add style targeting mat-horizontal-content-container
        const horizontalContentContainers = document.getElementsByClassName('mat-horizontal-content-container');
        if (horizontalContentContainers.length > 0) {
          for (let i = 0; i < horizontalContentContainers.length; i++) {
            (horizontalContentContainers[i] as HTMLElement).style.padding = '0';
          }
        }
        
        // Configure left section for payment step
        const leftSection = document.querySelector('.left-section') as HTMLElement;
        if (leftSection) {
         
          leftSection.style.padding = '0px';
         
        }

      } else {
        // this.denseLayoutComponent.orderReturnLogic = false;

        // Add style targeting mat-horizontal-content-container
      // Add style targeting mat-horizontal-content-container
        const horizontalContentContainers = document.getElementsByClassName('mat-horizontal-content-container');
        if (horizontalContentContainers.length > 0) {
          for (let i = 0; i < horizontalContentContainers.length; i++) {
            (horizontalContentContainers[i] as HTMLElement).style.padding = '0px 75px';
          }
        }
        
        // Configure left section for payment step
        const leftSection = document.querySelector('.left-section') as HTMLElement;
        if (leftSection) {
         
          leftSection.style.padding = '20px';
         
        }
      }
      // Mark for check
      this._changeDetectorRef.markForCheck();
    }

  async editInitialAddress() {
    this.isNewInitial = !this.isNewInitial;
    this.isLoading = true;
    await this.executeDepartLogic('kech');
    this.isLoading = false;

    this.selectedSecteurForm.patchValue({
      initialAddress: '',
      depart: null,
      initialLat: 0,
      initialLng: 0,
      initial_place_id: '',
    });

    console.log('CLEARED INITIAL STUFF ---!!');
  }

  clearPhoneValidators() {
    this.thirdStepForm.get('name')?.setValidators([]);
    this.thirdStepForm.get('phone')?.updateValueAndValidity();
    this.thirdStepForm.get('country')?.updateValueAndValidity();
    
  }


async fetchWalletInfo() {
  try {
    const data: any = await lastValueFrom(this.walletService.getWalletData());

    if (!data) return;

    console.log('FETCH WALLET INFO --> ', data);
    this.walletInfo = data.data;

    if (this.walletInfo) {
      this.paymentSelected(this.totalPriceTTC);
      // this.walletInfo.solde = 0;
    }

    if (data?.solde > 0) {
      // this.selectedSecteurForm.get('paymentMode').setValue(3);
      // this.selectedSecteurForm.updateValueAndValidity();
    }

    this._changeDetectorRef.markForCheck();
  } catch (error) {
    console.error('Erreur fetchWalletInfo:', error);
  }
}

   sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
   }
    getNumberByRetailId(retailId: string): number | undefined {
  return Number(
    Object.keys(this.cityPlaceIds).find(key => this.cityPlaceIds[key] === retailId)
  );
}
  async ngAfterViewInit(): Promise<void> {
    // this.loungeStepper.selectionChange.subscribe((value) => {
    //   console.log('SELECTION CHANGE --> ', value);
    //   if (value.selectedIndex === 1) {
    //     this.denseLayoutComponent.orderReturnLogic = true;
    //   } else {
    //     this.denseLayoutComponent.orderReturnLogic = false;
    //   }
    //   // Mark for check
    //   this._changeDetectorRef.markForCheck();
    // });

    // this.coords11 = polygon.map((coor:any) => ({
    //   lat: new google.maps.LatLng(coor).lat(),
    //   lng: new google.maps.LatLng(coor).lng(),
    // }));

    // this.coords22 = polygon2.map((coor:any) => ({
    //   lat: new google.maps.LatLng(coor).lat(),
    //   lng: new google.maps.LatLng(coor).lng(),
    // }));

    if (!isPlatformBrowser(this.platformId) || window === undefined) return;
    if(typeof google === 'undefined'){
        await this.sleep(500);

        // return;
    }

    await this.googleMapsService.loadGoogleMapsScript();

    this.retailesObjects= await firstValueFrom(this._orderService.getRetailers());
    console.log('RETAILERS OBJECTS ==> ', this.retailesObjects);
    console.log('DEPART QUERY PARAM ==> ', this.departQueryParam);
    let selectedRetailer= this.retailesObjects.filter((retailer:any) => retailer.onlineTitle==this.departQueryParam);
    console.log('SELECTED RETAILER FROM QUERY PARAM ==> ', selectedRetailer);
    if(this.departQueryParam){
        console.log('Initial address set to Aéroport Marrakech Ménara',selectedRetailer[0].retailerId)
       await this.selectedRetailer({value:selectedRetailer[0].retailerId})
      }
    if(typeof google.maps.places === 'undefined') {
        await this.sleep(500);
        alert('Google Maps API is not loaded');

    } 
    if (!this._router.url.includes('ticket-confirmation')) {
        this._splashScreenService.hide();
    }

    console.log('DATA SEO IN AFTER VIEW INIT ==> ', this.dataSeo);
    if(this.dataSeo && this.dataSeo.city){
      // alert('Setting initial city from SEO data: ' + this.dataSeo.city);
      let citySeo= this.dataSeo.city;

          if(this.cityPlaceIds[citySeo]){
            console.log('Initial address set to city from SEO data', citySeo)
            await this.selectedRetailer({value:this.cityPlaceIds[citySeo]})
          }
    }

    let autocompleteSrv = new google.maps.places.AutocompleteService();

    this.placeSendQuery
      .pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(300),
        filter((data) => data && typeof data === 'string')
      )
      .subscribe(async (data: any) => {
        this.locations = await new Promise((resolve, reject) => {
          autocompleteSrv.getPlacePredictions(
            {
              input: data,
              componentRestrictions: { country: 'ma' },
            },
            (predictions:any, status:any) => {
              if (status == google.maps.places.PlacesServiceStatus.OK) {
                resolve(predictions);
                // Mark for check
                this._changeDetectorRef.markForCheck();
              } else {
                resolve([]);
                // Mark for check
                this._changeDetectorRef.markForCheck();
              }
            }
          );
        });
      });

    this.pricingControl.valueChanges
      .pipe(
        takeUntil(this._unsubscribeAll),
        filter((val) => val),
        tap(async () => {
          console.log('PRICING CONTROL START !!!');
          this.isLoading = true;

          // Mark for check
          this._changeDetectorRef.markForCheck();
          return of([]);
        }),
        debounceTime(1000),
        switchMap(async (query) => {
          console.log('PRICING CONTROL EXECUTE !!!');
          await this.updatePrice();

          // Mark for check
          this._changeDetectorRef.markForCheck();
          return of([]);
        }),
        map(() => {
          console.log('PRICING CONTROL FINISHED !!!');

          this.isLoading = false;
          // Mark for check
          this._changeDetectorRef.markForCheck();
        })
      )
      .subscribe();

    this.locationsSearch.valueChanges
      .pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(300),
        switchMap((query) => {
          this.isLoading = true;
          this.getAutocompletePredictions(query);

          return of([]);
        }),
        map(() => {
          this.isLoading = false;
        })
      )
      .subscribe();

    this.firstStepForm
      .get('destination')?.valueChanges.pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(500),
        switchMap((query) => {
          console.log('DESTINATION FORMCONTROL NAME QUERY ===> ', query);
          this.isLoading = true;
          if (typeof query === 'string' && query?.length > 2) {
            // if (this.googleMode) {
            return of(this.getAutocompletePredictions(query));
            // } else {
            // return this._orderService.getSearchSecteurs(
            //   query,
            //   this.currentRetailerId
            // );
            //}
          } else {
            this.isLoading = false;
            return of();
          }

          //}
        }),
        map(() => {
          this.isLoading = false;
        })
      )
      .subscribe();

    this.firstStepForm.get('depart')
      ?.valueChanges.pipe(
        takeUntil(this._unsubscribeAll),
        debounceTime(500),
        switchMap((query) => {
          console.log('DEPART FORMCONTROL NAME QUERY ===> ', query);
          this.isLoading = true;
          console.log("hello")
          if (typeof query === 'string' && query?.length > 2) {
            // if (this.googleMode) {
            return of(this.getAutocompletePredictions(query));
            // } else {
            // return this._orderService.getSearchSecteurs(
            //   query,
            //   this.currentRetailerId
            // );
            //}
          } else {
            this.isLoading = false;
            return of();
          }

          //}
        }),
        map(() => {
          this.isLoading = false;
        })
      )
      .subscribe();

    // this.firstStepForm
    //   .get('time')
    //   ?.valueChanges.subscribe(async (value) => {
    //     console.log('TIME VALUE ==> ', value);

    //     //let timeRes = this.checkTime();

    //     if (this.selectedSecteurForm.get('time')?.invalid) {
    //       console.log('INVALID');
    //       return;
    //     }
    //     console.log('SELECTEd SECTEUR ==> ', this.selectedSecteur);

    //     //! Check if retour or aller mode
    //     //! If retour we use retourVehics/ else we use taxis

    //     this.currentTime = value;

    //     if (this.selectedSecteur?.taxis?.length) {
    //       // let secteurItem: any = {};
    //       // let currentTime = value
    //       //   ? moment(value + ':00').format('hh:mm')
    //       //   : moment(new Date()).format('hh:mm');
    //       let priceTag = await this.returnPriceTag(value);
    //       console.log('PRICE TAG ==> ', priceTag);
    //       // let format = 'hh:mm:ss';

    //       // let currentTime = value
    //       //   ? moment(value + ':00', format)
    //       //   : moment(new Date());
    //       // console.log('CURRENT TIME ==> ', currentTime);
    //       // let time = currentTime.tz(this.timezone),
    //       //   beforeTime = moment('06:00:00', format).tz(this.timezone),
    //       //   afterTime = moment('21:00:00', format).tz(this.timezone);

    //       // if (time.isBetween(beforeTime, afterTime)) {
    //       //   priceTag = 'morningPrice';
    //       // } else {
    //       //   priceTag = 'nightPrice';
    //       // }
    //       let taxis = this.selectedSecteur.taxis;
    //       let retourVehics = this.selectedSecteur.retourVehics;

    //       let forcedType = 0;

    //       if (taxis?.length === 1) {
    //         forcedType = taxis[0].id;
    //       }

    //       let retour = this.selectedSecteurForm.get('retour')?.value ?? false;

    //       this.selectedSecteur = {
    //         ...this.selectedSecteur,
    //         price: retour
    //           ? retourVehics[0][priceTag]
    //           : taxis[0][priceTag],
    //         type: retour ? retourVehics[0].id : taxis[0].id,
    //         retourVehics: retourVehics,
    //         retourVehicsTypes: retourVehics?.map((vehic:any) => vehic.id),
    //         qty: 1,
    //         availableTypes: taxis?.map((vehic:any) => vehic.id),
    //         priceTag,
    //         isNight: priceTag == 'nightPrice' ? true : false,
    //         forcedType,
    //       };

    //       console.log('SECTEU ITEM ===> ', this.selectedSecteur);
    //       this.quotaItem = this.selectedSecteur;
    //       this.buildFormControl(this.selectedSecteur);
    //       this.selectedSecteurForm.updateValueAndValidity();
    //       this.calculateAllTTC();
    //     }
    //   });

    setTimeout(() => {
      this.animationState = 'rotated';
      setTimeout(() => {
        this.animationState = 'initial';
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }, 1000); // matches the animation duration
      // Mark for check
      this._changeDetectorRef.markForCheck();
    }, 500);

     this.firstStepForm.get('time')?.valueChanges.subscribe(async (value) => {
  console.log('TIME VALUE ==> ', value);
  const timeControl = this.firstStepForm.get('time');
  if (timeControl?.invalid) {
    console.log('INVALID TIME');
    return;
  }

  const dateControl = this.firstStepForm.get('date');
  const currentDateValue = dateControl?.value;

  if (currentDateValue && value) {
    const datePart = new Date(currentDateValue);
    let [hourStr, minuteStr] = value.split(':');
    let hour = parseInt(hourStr, 10);
    let minute = parseInt(minuteStr, 10);

    // Ajoute 10 minutes
    // minute += 10;
    // if (minute >= 60) {
    //   minute -= 60;
    //   hour += 1;
    // }
    // if (hour >= 24) {
    //   hour = 0;
    // }

    // Met à jour le champ time avec le nouvel horaire (optionnel)
    const updatedTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
    this.firstStepForm.get('time')?.setValue(updatedTime, { emitEvent: false });

// Supposons que datePart est un objet Date ou notre mini-moment-like
// hour et minute sont définis
const dateObj = new Date(
  datePart.getFullYear(),   // année
  datePart.getMonth(),      // mois (0-11)
  datePart.getDate(),       // jour
  hour,
  minute,
  0,
  0
);

// Appliquer le fuseau horaire via mini-moment
const localDate = this.myMoment.tz(dateObj); // renvoie un objet Date ajusté au fuseau

// Obtenir la chaîne ISO
const isoUtc = localDate.toISOString();

console.log('UPDATED ISO DATE ==> ', isoUtc);


    dateControl.setValue(isoUtc, { emitEvent: false });
    this.currentDate = isoUtc;
    this.currentTime = updatedTime;

    // if (!this.firstStepForm.invalid) {
    //   console.log('DATE VALUE ==> ', this.firstStepForm.get('date')?.value);
    //   await this.updatePrice();
    // }
  }



  // Vérifie et met à jour les véhicules disponibles et le prix
  // if (!this.selectedSecteur?.taxis?.length) return;

  // const priceTag = await this.returnPriceTag(value);
  // const retour = this.selectedSecteurForm.get('retour')?.value ?? false;

  // const taxis = this.selectedSecteur.taxis;
  // const retourVehics = this.selectedSecteur.retourVehics;

  // const selectedVehic = retour ? retourVehics[0] : taxis[0];
  // const forcedType = taxis.length === 1 ? taxis[0].id : 0;

  // this.selectedSecteur = {
  //   ...this.selectedSecteur,
  //   price: selectedVehic[priceTag],
  //   type: selectedVehic.id,
  //   retourVehics,
  //   retourVehicsTypes: retourVehics.map((v: any) => v.id),
  //   qty: 1,
  //   availableTypes: taxis.map((v: any) => v.id),
  //   priceTag,
  //   isNight: priceTag === 'nightPrice',
  //   forcedType,
  // };

  // console.log('UPDATED SECTEUR:', this.selectedSecteur);
  // this.quotaItem = this.selectedSecteur;
  // this.buildFormControl(this.selectedSecteur);
  // this.selectedSecteurForm.updateValueAndValidity();

  // this.calculateAllTTC();
});




    let queryParamsObj = this._activatedRoute.snapshot.queryParamMap;

    let did = queryParamsObj.get('did') ?? '';

    this.currentPlacement = did;

    
  }

  // Receive user input and send to search method**
  onKey(event:any) {
    let value = event.target?.value;
    this.filteredCountries = this.search(value);
  }

  // Filter the states list and send back to populate the selectedStates**
    search(value: string | number) {
      let filter = value.toString().toLowerCase();
      return this.countries.filter(
        (option: any) =>
          option?.name?.toLowerCase().includes(filter) ||
          option?.code?.toLowerCase().includes(filter) ||
          option?.iso?.toLowerCase().includes( filter)
      );
    }

  keyPressTime(event: KeyboardEvent) {
    console.log('KEY PRESS EVENT ==> ', event);
    const pattern = /[0-9]/;
    const inputChar = event.key;
    let value = this.selectedSecteurForm.get('time')?.value ?? '';
    let value1 = (this.selectedSecteurForm.get('time')?.value ?? '') + event.key;

    console.log('Value ==> ', value);

    if (
      event.code === 'Backspace' ||
      event.key === 'Backspace' ||
      event.code === 'ArrowLeft' ||
      event.code === 'ArrowRight'
    ) {
      return;
    }

    if (value1.length == 1 && /^[0-9]+$/.test(inputChar)) {
      console.log('A NUMBER ????1!!');
    } else if (value1.length == 2 && /^[0-9]+$/.test(inputChar)) {
      console.log('A NUMBER ????1!!');
      this.selectedSecteurForm.get('time')?.setValue(value1 + ':');
      event.preventDefault();
    } else if (
      value1.length == 3 &&
      (event.key === ':' || event.code === 'Semicolon')
    ) {
      console.log('A SEMICOLON');
    } else if (value1.length == 3 && /^[0-9]+$/.test(inputChar)) {
      this.selectedSecteurForm.get('time')?.setValue(value + ':' + inputChar);
      event.preventDefault();
    } else if (
      (value1.length == 4 || value1.length == 5) &&
      /^[0-9]+$/.test(inputChar)
    ) {
      console.log('A NUMBER ????1!!');
    } else {
      event.preventDefault();
    }
  }

  checkTime(): boolean {
    let value = this.selectedSecteurForm.get('time')?.value;

    if (!value || value === '') {
      return false;
    }
const now = new Date();

const currentTime = this.myMoment.format(
  this.myMoment.tz(now),
  { hour: '2-digit', minute: '2-digit', hour12: false }
);

const currentDate = this.myMoment.format(
  this.myMoment.tz(now),
  { day: '2-digit', month: '2-digit', year: 'numeric' }
);

console.log(currentTime); // "18:25"
console.log(currentDate); // "04/11/2025"

    let selectedHour = value.split(':')[0];
    let selectedMinutes = value.split(':')[1];
    let currentDay = currentDate.split('/')[0];
    let currentMonth = currentDate.split('/')[1];
    let currentYear = currentDate.split('/')[2];

    console.log(' TIMES => ', {
      currentDate,
      currentTime,
      selectedHour,
      selectedMinutes,
      currentDay,
      currentMonth,
      currentYear,
    });
const dateValue = this.selectedSecteurForm.get('date')?.value;

if (dateValue) {
  const selectedDate = this.myMoment.format(
    this.myMoment.tz(new Date(dateValue)),
    { day: '2-digit', month: '2-digit', year: 'numeric' }
  );

  console.log(selectedDate); // "04/11/2025"
}


    let selectedDay = currentDate.split('/')[0];
    let selectedMonth = currentDate.split('/')[1];
    let selectedYear = currentDate.split('/')[2];

    console.log('SELECTED DATE ==> ', {
      selectedDay,
      selectedMonth,
      selectedYear,
    });

    if (
      currentTime &&
      +selectedDay == +currentDay &&
      +selectedMonth == +currentMonth &&
      +selectedMonth == +currentMonth
    ) {
      let currentHour = currentTime.split(':')[0];
      let currentMinutes = currentTime.split(':')[1];

      console.log(' TIMES 1 => ', { selectedHour, selectedMinutes });
      console.log(' TIMES 2 => ', { currentHour, currentMinutes });

      if (
        +selectedHour < +currentHour ||
        (+selectedHour == +currentHour && +selectedMinutes < +currentMinutes)
      ) {
        console.log('TIME IS NOT RIGHT');
        this.selectedSecteurForm.get('time')?.setValue('');
        if (this.loungeStepper.selectedIndex !== 0) {
        this.loungeStepper.selectedIndex = 0;
          }
        return false;
      }
    }

    let invalid = [];
    let controls = this.selectedSecteurForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log('INVALID ==> ', invalid);
    return true;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
        this.countdownSubscription?.unsubscribe();
    this._unsubscribeAll.complete();
    if(this.socket) this.socket.disconnect();
  }

  valueChanged($event: any) {
    const datePart = new Date($event.value);  // date sélectionnée
    const timePart = this.firstStepForm.get('time')?.value;
    
    console.log('DATE PART ==> ', datePart);
    console.log('TIME PART ==> ', timePart);

    if (!timePart || isNaN(datePart.getTime())) {
      console.warn('Invalid time or date');
      return;
    }

const [hour, minute] = timePart.split(':').map(Number); // Convertir en nombre

const localDate = new Date(
  datePart.getFullYear(),   // année
  datePart.getMonth(),      // mois (0 = janvier)
  datePart.getDate(),       // jour
  hour,                     // heure
  minute,                   // minute
  0,                        // seconde
  0                         // millisecondes
);

console.log(localDate);


    console.log('LOCAL DATE ==> ', localDate.toISOString());

    // Convertit en UTC ISO string
    const isoUtc = localDate.toISOString();

    console.log('SET TIMEZONE ==> ', isoUtc);  

    this.firstStepForm.get('date')?.setValue(isoUtc);
    this.firstStepForm.get('dateShow')?.setValue(isoUtc, { emitEvent: false });
    this.currentDate = isoUtc;
  }



  @ViewChild('testForm') testFormElement?: ElementRef;

  public currentUserEmail: string = '';

  orderLoading: boolean = false;
  paymentResult: any;
  /**
   * Cash create order
   * @returns
   */
  public async placeOrder() {
    if (
      this.selectedSecteurForm.invalid ||
      this.eventForm1.invalid ||
      this.isLoading ||
      this.orderLoading
    ) {
      return;
    }

    // return;
    this.orderLoading = true;
    this._splashScreenService.show();
    //await this.checkStepper();

    this.loungeStepper._steps.forEach((step:any) => (step.editable = false));

const now = new Date();

// Appliquer le fuseau horaire et obtenir l'ISO string
const latestDate = this.myMoment.tz(now).toISOString();

console.log('LATEST DATE ==> ', latestDate);

    let secteurForm = this.selectedSecteurForm.getRawValue();
    let eventForm = this.eventForm1.getRawValue();
    secteurForm = { ...secteurForm, ...eventForm };
    secteurForm.retailerId = this.currentRetailerId;

    try {
      let result = null;

      if (!this.isClient) {
        result = await lastValueFrom(
          this._orderService.paySpecial({
            // ...billingForm,
            ...secteurForm,
            ht: this.totalPriceHT,
            ttc: this.totalPriceTTC,
            amount: this.totalPriceTTC,
            tva: this.totalPriceTVA,
            timeStamp: latestDate,
            tz: this.timezone,
            placement: this.currentPlacement,
            totalOptions: this.totalPriceOptions,
          })
        );
      } else {
        result = await lastValueFrom(
          this._orderService.paySpecialV2({
            // ...billingForm,
            ...secteurForm,
            ht: this.totalPriceHT,
            ttc: this.totalPriceTTC,
            amount: this.totalPriceTTC,
            tva: this.totalPriceTVA,
            timeStamp: latestDate,
            tz: this.timezone,
            placement: this.currentPlacement,
            totalOptions: this.totalPriceOptions,
          })
        );
      }
      console.log('RESUT ==> ', result);

      if (result?.success) {
        //? Display Dialog with Success message
        let title = 'Success';
        let message = 'Ticket Created Successfully!';
        this.openDialog(title, message, this.successIcon);
        this.orderLoading = false;
        this._splashScreenService.hide();
        let ticketId = result?.items[0]?._id;

      } else {
        //! If we get activeTrip = true then client already has an active Trip
        //! We display a dialog to cancel it before proceeding
        if (result?.activeTrip && result?.activeTripId) {
          let title = 'Active Trip';
          let message = 'Cancel Active in order to make a new one?';
          this.openDialog(title, message, this.infoIcon, true, () => {
            this;
          });
        } else {
          //? Display Dialog with Error message
          let title = 'Error';
          let message = 'Something not right!';
          this.openDialog(title, message);
        }

        // this.denseLayoutComponent.orderReturnLogic = false;
        this.orderLoading = false;
        this._splashScreenService.hide();
      }
      // Mark for check
      this._changeDetectorRef.markForCheck();
    } catch (err) {
      //? Display Dialog with Success message
      let title = 'Error';
      let message = 'Something not right!';
      this.openDialog(title, message);
      // this.denseLayoutComponent.orderReturnLogic = false;
      this.orderLoading = false;
      this._splashScreenService.hide();
      // Mark for check
      this._changeDetectorRef.markForCheck();
    }
  }
  openDialogINtiemOut(
    title:any,
    message:any,
    icon:any = null,
    action:any = false,

    okCallBack = () => {},
    noCallBack = () => {}
  ) {
    let configForm = this.buildForm(title, message, icon, false);
    this.openConfirmationDialogInTimeOut(configForm, action, okCallBack, noCallBack);
  }

  openDialog(
    title:any,
    message:any,
    icon:any = null,
    action:any = false,

    okCallBack = () => {},
    noCallBack = () => {}
  ) {
    let configForm = this.buildForm(title, message, icon, action);
    this.openConfirmationDialog(configForm, action, okCallBack, noCallBack);
  }

  /**
   * Redirect user to transaction ticket
   * @param id
   */
  goToTransactionTicket(id:any) {
    this._router.navigate(['/transaction-ticket/' + id]);
  }

  placeSendQuery: BehaviorSubject<any> = new BehaviorSubject('');

  currentYear = new Date().getFullYear();

  private getAutocompletePredictions(query:any): Observable<any> {
    if (query.length < 4 || !(typeof query === 'string')) {
      return of();
    }

    this.placeSendQuery.next(query);
    return of();
  }

  fireClickEvent(element:any) {
    var evt = new window.MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    element.dispatchEvent(evt);
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
    this.calculateAllTTC();
  };

  async resetEverything() {
    this.departControl.setValue('');
    this.locations = [];
    this._orderService.clearSecteurs();
    // this.qtySliderPptions = null;
    // this.lggSliderPptions = null;
    this.qtySliderPptions.stepsArray = [];
    this.lggSliderPptions.stepsArray = [];
    this.selectedSecteurForm.patchValue({
      title: '',
      ht: 0,
      ttc: 0,
      tva: 0,
      price: 0,
      // qty: 1,
      // luggage: 1,
      type: 0,
      forcedType: 0,
      availableTypes: [],
      taxis: [],
      retourVehics: [],
      retourVehicsTypes: [],
      zoneId: '',
      zoneName: '',
      secteur: '',
      secteurLng: '',
      secteurId: '',
      lng: '',
      lat: '',
      place_id: '',
      tz: '',
      fixedSecteurPrice: 0,
      destination: null,
    });
    this.loungeStepper._steps.forEach(
      (step:any) => ((step.editable = true), (step.completed = false))
    );

    this.totalRemise = 0;
    this.totalCount = 0;
    this.totalCleanPriceHT = 0;
    this.totalPriceToDisplay = 0;
    this.totalPriceToDisplaySignal.set(0);
    this.totalPriceOptions = 0;
    this.totalPriceHT = 0;
    this.totalPriceTTC = 0;
    this.totalPriceTVA = 0;
    this.loungeStepper.selectedIndex = 0;
    this.eventForm.reset();
    this.eventForm1.reset();
    //this.clearFormArray(this.adultPassengersFormArray);
    // this.buildFormControl1();
    //this.clearFormArray(this.childrenPassengersFormArray);
    // this.clearFormArray(this.babiesPassengersFormArray);
    this.billingForm.reset();
    this.paymentForm.reset();
    this.quotaSteps.selectedIndex = 0;
    // this.eventForm = this._formBuilder.group({
    //   _id: [''],
    //   packId: [1],
    // });

    // this.eventForm1 = this._formBuilder.group({
    //   _id: [''],
    //   date: ['', [Validators.required]],
    //   time: [
    //     '',
    //     [
    //       Validators.pattern('^(0[0-9]|1[0-9]|2[0-4]|[0-9]):([0-5][0-9])'),
    //       Validators.required,
    //     ],
    //   ],
    //   flightNum: ['', [Validators.required]],
    //   adultPassengers: new FormArray([]),
    //   childrenPassengers: new FormArray([]),
    //   babiesPassengers: new FormArray([]),
    //   status: [1],
    //   isPayed: [true],
    //});

    this.billingForm = this._formBuilder.group({
      fname: [''],
      name: [''],
      middleName: '',
      //company: "",
      email: ['', [Validators.email]],
      phone: [''],
      //country: ["", ],
      city: [''],
      state: '',
      zip: [''],
      address: [''],
    });

    this.paymentForm = this._formBuilder.group({
      cardHolderName: [''],
      cardNumber: [''],
      expiredDate: [''],
      clearExpiredDate: [''],
      //expiredYear: ["", ],
      cvv: [''],
    });

    this.calculateAllTTC();

    // this.eventForm1
    //   .get('date')
    //   .setValue(
    //     moment(moment(new Date()).toISOString())
    //       .utcOffset(moment().utcOffset())
    //       .toISOString()
    //   );

this.currentDate = this.myMoment.tz(new Date()).toISOString();

console.log(this.currentDate);

    this.loungeStepper.selectedIndex = 0;
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  keyPress(event: KeyboardEvent) {
    console.log('KEY PRESS EVENT ==> ', event);
    const pattern = /[0-9]/;
    const inputChar = event.key;
    if (
      /^[0-9]+$/.test(inputChar) ||
      event.code === 'Backspace' ||
      event.key === 'Backspace' ||
      event.code === 'ArrowLeft' ||
      event.code === 'ArrowRight'
    ) {
      console.log('A NUMBER ????1!!');
    } else {
      console.log('preventDefault');

      event.preventDefault();
    }
  }

  keyPressPay(event: KeyboardEvent, type: 'keyup' | 'keydown') {
    const pattern = /[0-9]/;
    const inputChar = event.key;
    let currentValue = this.paymentForm.get('expiredDate')?.value;
    if (
      currentValue.length === 0 &&
      /^[0-9]+$/.test(inputChar) &&
      parseInt(inputChar) < 10 &&
      parseInt(inputChar) > 1 &&
      type === 'keydown'
    ) {
      this.paymentForm.patchValue({
        expiredDate: '0' + inputChar + ' / ',
        clearExpiredDate: '0' + inputChar,
      });

      event.preventDefault();
    }

    if (
      currentValue.length === 0 &&
      /^[0-9]+$/.test(inputChar) &&
      parseInt(inputChar) === 1 &&
      type === 'keydown'
    ) {
    }

    if (
      currentValue.length === 2 &&
      (event.code === 'Space' || event.key === ' ') &&
      type === 'keydown'
    ) {
      this.paymentForm.patchValue({
        expiredDate: currentValue + ' / ',
        clearExpiredDate: currentValue,
      });

      event.preventDefault();
    }

    if (
      currentValue.length === 2 &&
      /^[0-9]+$/.test(inputChar) &&
      type === 'keydown'
    ) {
      this.paymentForm.patchValue({
        expiredDate: currentValue + ' / ' + inputChar,
        clearExpiredDate: currentValue + inputChar,
      });

      event.preventDefault();
    }

    if (
      currentValue.length === 1 &&
      /^[0-9]+$/.test(inputChar) &&
      type === 'keydown'
    ) {
      if (currentValue == '1' && parseInt(inputChar) > 2) {
        event.preventDefault();
      } else if (
        currentValue == '1' &&
        parseInt(inputChar) <= 2 &&
        parseInt(inputChar) > 0
      ) {
        // Good
        this.paymentForm.patchValue({
          expiredDate: currentValue + inputChar + ' / ',
          clearExpiredDate: currentValue + inputChar,
        });

        event.preventDefault();
      } else if (currentValue == '0' && parseInt(inputChar) <= 9) {
        // Good
        this.paymentForm.patchValue({
          expiredDate: currentValue + inputChar + ' / ',
          clearExpiredDate: currentValue + inputChar,
        });

        event.preventDefault();
      }
    }

    if (
      /^[0-9]+$/.test(inputChar) &&
      (currentValue.length === 5 || currentValue.length === 6) &&
      type === 'keydown'
    ) {
      let clearValue = this.paymentForm.get('clearExpiredDate')?.value;
      this.paymentForm.get('clearExpiredDate')?.setValue(clearValue + inputChar);
    }

    if (
      currentValue.length === 6 &&
      (event.code === 'Backspace' || event.key === 'Backspace') &&
      type === 'keydown'
    ) {
    }

    if (
      (currentValue.length === 6 || currentValue.length === 5) &&
      (event.code === 'Backspace' || event.key === 'Backspace') &&
      type === 'keyup'
    ) {
      let clearValue = this.paymentForm.get('expiredDate')?.value;
      this.paymentForm
        .get('clearExpiredDate')
        ?.setValue(
          (clearValue.split(' / ')[0] ?? '') +
            (clearValue.split(' / ')[1] ?? '')
        );
      return;
    }

    if (
      (currentValue.length === 5 || currentValue.length === 6) &&
      !/^[0-9]+$/.test(inputChar) &&
      event.code !== 'Backspace' &&
      event.key !== 'Backspace' &&
      event.code !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      type === 'keydown'
    ) {
      event.preventDefault();
    }

    if (
      currentValue.length === 5 &&
      (event.code === 'Backspace' || event.key === 'Backspace') &&
      type === 'keydown'
    ) {
      this.paymentForm.patchValue({
        expiredDate: currentValue.substring(0, 3),
        clearExpiredDate: currentValue.substring(0, 3),
      });
    }

    if (
      currentValue.length === 7 &&
      event.code !== 'Backspace' &&
      event.key !== 'Backspace' &&
      type === 'keydown'
    ) {
      event.preventDefault();
    }

    if (
      (currentValue.length === 2 || currentValue.length === 7) &&
      (event.code === 'Backspace' || event.key === 'Backspace') &&
      type === 'keydown'
    ) {
    }
    // if length == 7 then we are done
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------
  totalPriceToDisplaySignal = signal<number>(0); // ou signal<number | null>(null)

  calculateAllTTC() {
    console.log('CALCULATE ALL TTC');
    // if (!this.extraOptions) {
    //   return;
    // }

    let item = this.calculatePriceForm.getRawValue();
    let secondForm = this.secondStepForm.getRawValue();
    item = { ...item, ...secondForm };
    console.log('CALCUALTE ALL TTC ==> ', item);
    if (item) {

      let pet = 0;
      let options = 0;







      let extraLugagge = 0;
      // ht =  (item.price ?? 0);

      let ht = (item.price ?? 0);


      // if (item.type === 1 && item.luggage > 3) {
      //   extraLugagge += (item.luggage - 3) * 5;
      // }
      if (item.isDog) {
        pet += 50;
      }
      if (item.isSurf) {
        extraLugagge += 30;
      }
      if (item.isGolf) {
        extraLugagge += 30;
      }
      if (item.isHandicapped) {
        extraLugagge += 30;
      }
      if (item.isBicycle) {
        extraLugagge += 30;
      }
      options += (extraLugagge ?? 0) + (pet ?? 0) ;
      //ht += (extraLugagge ?? 0) + (pet ?? 0);

      // console.log('EXTRA ==> ', extra);
      // this.totalCleanPriceHT = +(ht ?? 0);
      this.selectedSecteurForm.patchValue({
        //ht: this.totalCleanPriceHT,
        price: this.totalCleanPriceHT,
        newPrice: this.totalCleanPriceHT,
      });
      this.totalPriceHT = +(ht ?? 0);
      this.totalPriceTTC = +(ht ?? 0) 
      this.totalPriceOptions = options;
      this.totalPriceTTC=ht;
      this.totalPriceToDisplay = this.roundTwoDecimals(
         ht + options
      );

      // this.calculatePriceForm.patchValue({
      //   price: this.totalPriceToDisplay
      // });

      
      this.totalPriceToDisplaySignal.set(this.totalPriceToDisplay);
      console.log('TOTAL PRICE TO DISPLAY ==> ', this.totalPriceToDisplay);
      this._changeDetectorRef.markForCheck();
      // this.totalRemise = +(remise ?? 0);
      // this.totalCount = +(count ?? 0);
    } else {
      this.totalPriceTVA = 0;
      this.totalPriceHT = 0;
      this.totalCleanPriceHT = 0;
      this.selectedSecteurForm.patchValue({
        ht: this.totalCleanPriceHT,
        price: this.totalCleanPriceHT,
        newPrice: this.totalCleanPriceHT,
      });
      this.totalPriceTTC = 0;

      this.totalPriceToDisplay = 0;
      this.totalPriceToDisplaySignal.set(0);
      this.totalCount = 0;
      this.totalPriceOptions = 0;
    }
    // Mark for check
    this._changeDetectorRef.markForCheck();
    //this.checkIfDisplayNightTarif();
    console.log('TOTAL PRICE TVA => ', this.totalPriceTVA);
    console.log('TOTAL PRICE OPTOONS => ', this.totalPriceOptions);
    console.log('TOTAL HT OPTOONS => ', this.totalPriceHT);
    console.log('TOTAL TTC => ', this.totalPriceTTC);
  }

  listenToTripSocket(userId: any, ticketId: any) {
    if (!userId) {
      return;
    }
    console.log('LISTEN TO TRIPSOCKET --> ', { userId, ticketId });

    let subscriptions = this.socket?.subscriptions(false);

    console.log('SUBSCRIPTIONS --> ', subscriptions);
    // this.currentTripModeSignal = 1;

    (async () => {
      const myChannel = this.socket?.subscribe(
        'client-trip-broadcast-' + userId
      );
      (async () => {
        if (myChannel) {
          for await (let data of myChannel) {
            console.log('REALTIME TRIP BROADCAST MESSAGE => ', data);
            this.handleTripRealtime(data);
          }
        }
      })();
    })();
  }
  private tripUpdateChannel: any;

  /**
   * Listen to trip update
   * @param socket SocketClientCluster Object
   * @param ticketId The trip ticket Id
   * @returns
   */
    listenToTripUpdate(
      socket: socketClusterClient.AGClientSocket | null,
      ticketId: string
    ) {
      if (!socket || !ticketId) {
        return;
      }

      (async () => {
        this.tripUpdateChannel = socket.subscribe('orders-trip-geo-' + ticketId);

        for await (let data of this.tripUpdateChannel) {
          console.log('REALTIME TRIP BROADCAST MESSAGE => ', data);
          this.handleTripRealtime(data);
        }
      })();
    }


  maxDuration: number = 30000; // Default max duration for trip acceptance
  listenToTripSocketAccepted(userId: any, ticketId: any, maxDuration: number = 30000,isStartProgressTimer: boolean=true) {
    console.log('LISTEN TO TRIPSOCKET --> ', { userId, ticketId });
    if (!userId) {
      return;
    }

    let subscriptions = this.socket?.subscriptions(false);
    this.currentTripModeSignal.set(1); 
          const total = 30;
          console.log('TOTAL ==> ', total); 
          this.maxDuration = maxDuration;
    if(this.tripType!=2 && isStartProgressTimer)      this.startProgressTimer(maxDuration/1000)
      

    console.log('SUBSCRIPTIONS --> ', subscriptions);
    this.currentTripStatus.set(0);
      this._changeDetectorRef.markForCheck();

    this.listenToTripUpdate(this.socket, ticketId);
  }

  isCanRetryTrip = signal<boolean>(false); 

  startProgressTimer(maxDuration: number = 30) {
    let total = maxDuration;
    if (this.interval) clearInterval(this.interval);
    this.isCanRetryTrip.set(false);

    this.progressBar.set({
      name: 'Réponse au trajet',
      secondsLeft: total,
    progress: 100
  });

  console.log('START PROGRESS TIMER ==> ', this.progressBar());

  this.interval = setInterval(() => {
    const current = this.progressBar();

    if (current.secondsLeft > 0) {
      const secondsLeft = current.secondsLeft - 1;
      const progress = (secondsLeft / total) * 100;

      
      this.progressBar.update(p => ({
        ...p,
        secondsLeft,
        progress
      }));
      console.log(`⏳ Temps restant  ${secondsLeft} secondes`);  
      console.log(this.progressBar().progress);
      this._changeDetectorRef.markForCheck();
    } else {
      clearInterval(this.interval);
      console.log(`⛔ Temps écoulé pour ${current.name}`);
      this.isCanRetryTrip.set(true);
      this._changeDetectorRef.markForCheck();
      console.log("isCanRetryTrip",this.isCanRetryTrip())
      // this.cancelTripInTimeOut(this.ticketId); 
    }
  }, 1000);
}
  async retryTrip(tripId: string) {
    try {
  this.driversNotify = [];
  this.isCanRetryTrip.set(false);
  this.startProgressTimer(this.maxDuration/1000);
  let res=await firstValueFrom(this.clientService.notifyDrivers(tripId));
  this.isCanRetryTrip.set(false);
  console.log('RETRY TRIP RES ==> ', res);
    } catch (error) {
      console.error('Error retrying trip:', error);
      // this.isCanRetryTrip.set(true);
      this._changeDetectorRef.markForCheck();
    }
}



getDriverTitleMessage(): string {
  switch (this.currentTripStatus()) {
    case 3:
      return this.translateService.translateKey('TRIP.DRIVER_ARRIVED');
    case 4:
      return this.translateService.translateKey('TRIP.inProgress');
    case 5:
      return this.translateService.translateKey('TRIP.completed');
    case 6:
      return this.translateService.translateKey('TRIP.TRIP_CANCELLED');
    case 7:
      return this.translateService.translateKey('TRIP.TRIP_EXPPIRED');
    default:
      return this.translateService.translateKey('TRIP.DRIVER_ASSIGNED');
  }
}

getDriverStatusMessage(): string {
  switch (this.currentTripStatus()) {
    case 3:
      return this.translateService.translateKey('tripStatus.arrived');
    case 4:
      return this.translateService.translateKey('tripStatus.inProgress');
    case 5:
      return this.translateService.translateKey('tripStatus.completed');
    default:
      return this.translateService.translateKey('tripStatus.waiting');
  }
}


  /**
   * Specifies current trip status
   * 0: Looking for drivers
   * 1: Waiting for drivers to accept
   * 2: Drivers search finished
   * 3: TRIP ACCEPTED, we fetch trip data
   */
  currentTripModeSignal= signal<number>(0); // 0: Looking for drivers, 1: Waiting for drivers to accept, 2: Drivers search finished, 3: TRIP ACCEPTED, we fetch trip data
  //? Current trip data like price/addresses and stuff
  currentTripData: any = null;
  //? Current fetched drivers while looking out
  currentDrivers :any[]= [];
  //? Trip fech after being accepted
  tripData :any= null;

  async handleTripRealtime(socketData: any) {
    if (!socketData) return;

    // Extraire les données principales
    const driverData = socketData?.data?.[0] || socketData; // supporte les deux formats
    // console.log('REALTIME TRIP BROADCAST MESSAGE ==> ', driverData);
    const status = socketData.status ?? driverData.status;
    this.currentTripStatus.set(status);
    if(status===6) this.driversNotify = [];
    clearInterval(this.interval);
    // Mettre à jour le mode de course
    // this.currentTripModeSignal = status ||  this.currentTripModeSignal;
    // this.currentTripModeSignal = driverData?.mode

    console.log('CURRENT TRIP MODE ==> ', this.currentTripModeSignal(),"driverData",driverData);
    this._changeDetectorRef.markForCheck();

    // Mettre à jour les données du chauffeur (tripData)
    if (!this.tripData&&driverData&&driverData.driverFullName)
      console.log('UPDATING TRIP DATA WITH DRIVER DATA ==> ', driverData);
      let driverPhoneCountry = driverData.driverPhoneCountry || '';
      this.tripData = {
        driverId: driverData.driverId,
        driverFullName: driverData.driverFullName,
        driverPhoneNumber:
          (driverPhoneCountry || '').replace('+', '') +
          driverData.driverPhoneNumber,
        driverPermis: driverData.driverPermis,
        driverCarModel: driverData.driverCarModel,
        driverCarPlateNumber: driverData.driverCarPlateNumber,
        taxiType: driverData.taxiType,
        taxi_num: driverData.taxiNum ?? '',
        driverAvgRatings: driverData.driverAvgRatings,
        driverPhoto: driverData.driverPhoto,
      };
      if(driverData.driverPhoto ){
        this.tripData.driverPhoto = driverData.driverPhoto;
      }
    // if (this.currentTripModeSignal === 2) this.tripData.driverPhoneNumber = driverData.driverPhoneCountry + driverData.driverPhoneNumber;

    console.log('TRIP DATA ==> ', this.tripData);

    // Déclencher la détection de changement manuelle
    // this._changeDetectorRef.detectChanges();
    this._changeDetectorRef.markForCheck();
    this._changeDetectorRef.detectChanges();

    // setInterval(() => {
    //   console.log('MARK FOR CHECK');
    //   this._changeDetectorRef.detectChanges();
    //   this._changeDetectorRef.markForCheck();
    // }
    // , 1000);
  }

  ifNumeric(text: string): boolean {
    if (/^[0-9.]*$/.test(text)) {
      return true;
    }
    return false;
  }

  ifDefault(text: string): boolean {
    if (text === '-') {
      return true;
    }
    return false;
  }

  ifpercentage(text: string): boolean {
    let number = text?.split('%')[0];
    if (this.ifNumeric(number) && text.endsWith('%')) {
      return true;
    }
    return false;
  }
  get luggageControl(): FormControl {
  return this.secondStepForm.get('luggage') as FormControl;
}

  numberKeyPress(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    const inputChar = event.key;
    if (
      /^[0-9]+$/.test(inputChar) ||
      event.code === 'Backspace' ||
      event.key === 'Backspace' ||
      event.code === 'ArrowLeft' ||
      event.code === 'ArrowRight'
    ) {
    } else {
      event.preventDefault();
    }
  }

  /**
   * Add event
   */
  async addEvent(): Promise<void> {
    if (this.selectedSecteurForm.invalid) {
      return;
    }
    this.quotaSteps.selectedIndex = 1;
  }

  currentTimezone = 'Africa/Casablanca';

  proceedLounge(val: number) {
    if (val) {
      this.eventForm.get('packId')?.setValue(val);
      this.loungeStepper.steps.get(0)!.completed = true;
      this.loungeStepper.next();
      // Mark for check
      this._changeDetectorRef.markForCheck();
    }
  }

  removeItem(type: number, index: number) {
    if (type === 0) {
      this.adultItems.splice(index, 1);
      this.adultPassengersFormArray.removeAt(index);
      this.adultPassengersFormArray.updateValueAndValidity();
    } else if (type === 1) {
      this.childrenItems.splice(index, 1);
      this.childrenPassengersFormArray.removeAt(index);
      this.childrenPassengersFormArray.updateValueAndValidity();
    } else if (type === 2) {
      this.babiesItems.splice(index, 1);
      this.babiesPassengersFormArray.removeAt(index);
      this.babiesPassengersFormArray.updateValueAndValidity();
    }
  }

  buildFormControl1() {
    this.adultItems.push({ type: '' });
    this.adultPassengersFormArray.push(
      this._formBuilder.group({
        t: ['Mr.'],
        fname: [''],
        name: [''],
        price: [30],
      })
    );
  }
  // isValideFirstStep():boolean{
  //   console.log('IS VALID FIRST STEP ==> ', this.firstStepForm.valid, this.calculatePriceForm.valid);
  //     if (!this.isBrowser) return false;
  //   return this.firstStepForm.valid && this.calculatePriceForm.valid;
  // }

  buildFormControl2() {
    this.childrenItems.push({ type: '' });
    this.childrenPassengersFormArray.push(
      this._formBuilder.group({
        fname: [''],
        name: [''],
        price: [30],
      })
    );
  }

  buildFormControl3() {
    this.babiesItems.push({ type: '' });
    this.babiesPassengersFormArray.push(
      this._formBuilder.group({
        fname: [''],
        name: [''],
        price: [0],
      })
    );
  }

  isCalculePriceValid: boolean = false;

  //! Update the whole price
  async updatePrice() {
    let form = this.firstStepForm.getRawValue();
    let tripType = this.calculatePriceForm.get('tripType')?.value;
    let forcedType = this.secondStepForm.get('forcedType')?.value;
    // if(tripType==3){
    //   forcedType=0

    // }

    // Get current time
    const now = new Date();

    // Add 30 minutes to now
    const nowPlus30 = new Date(now.getTime() + 30 * 60 * 1000);

    // Trip datetime from the form
    const tripTime = new Date(form.date);

    // Compare
    let finalDateTime;

    if (nowPlus30 > tripTime) {
      // If actual time passed trip time → use now + 30 minutes
      finalDateTime = nowPlus30
      this.firstStepForm.get('date')?.setValue(finalDateTime.toISOString(), { emitEvent: false });

      // Extraire l'heure et les minutes au format "HH:mm"
      const hours = finalDateTime.getHours().toString().padStart(2, '0');
      const minutes = finalDateTime.getMinutes().toString().padStart(2, '0');
      const timeString = `${hours}:${minutes}`;
      this.firstStepForm.get('time')?.setValue(timeString);
      finalDateTime=finalDateTime.toISOString();

    } else {
      // Otherwise keep the original trip time
      finalDateTime = tripTime.toISOString();
    }


    let body = {
      date_time: finalDateTime,
      destination_place_id: form.destination_place_id,
      destinationLat: form.destinationLat,
      destinationLng: form.destinationLng,
      initial_place_id: form.initial_place_id,
      initialLat: form.initialLat,
      initialLng: form.initialLng,
      luggageNb: this.secondStepForm.get('luggage')?.value ?? 0,
      passengersNb: this.secondStepForm.get('qty')?.value ?? 0,
      forcedType: forcedType ?? 0,
    }

    let secteurItem = await lastValueFrom(
      this._orderService.calculePriceTrips(body)
    );
    if(!secteurItem.success){
      this.calculatePriceForm.reset();
      this.isCalculePriceValid= false;
      let title = 'Error';
      let message = secteurItem.message || 'Error server!';
      if(secteurItem.message=='Invalid Date/time'){
      let dateValue = this.firstStepForm.get('date')?.value;
      let dateEnvoye = new Date(dateValue);
      let now = new Date();
      let diff = Math.abs(now.getTime() - dateEnvoye.getTime());
      console.log('DIFF ==> ', diff);

      if (diff < 10 * 60 * 1000) {
                let diff = Math.abs(now.getTime() - dateEnvoye.getTime());

              // Ajouter 10 minutes
              dateEnvoye = new Date(dateEnvoye.getTime() + 10 * 60 * 1000);

              // Mettre à jour le champ dans le formulaire
              this.firstStepForm.get('date')?.setValue(dateEnvoye.toISOString(), { emitEvent: false });

              // Extraire l'heure et les minutes au format "HH:mm"
              const hours = dateEnvoye.getHours().toString().padStart(2, '0');
              const minutes = dateEnvoye.getMinutes().toString().padStart(2, '0');
              const timeString = `${hours}:${minutes}`;
              this.firstStepForm.get('time')?.setValue(timeString);

        if (!secteurItem.success) {
          this.isCalculePriceValid = false;
          // this.openDialog('Error', secteurItem.message || 'Error server!', this.infoIcon);
          return;
        }
      }
      else{
      this.openDialog(title, message, this.infoIcon);
      return;
      }
    
      }
      else{
     
      this.openDialog(title, message, this.infoIcon);
      return;
      }
    }
    this.isCalculePriceValid = true;

    if (secteurItem.validOptions.maxPassengers) {
           this.qtySliderPptions.stepsArray = Array.from({ length: secteurItem.validOptions.maxPassengers }, (_, i) => ({ value: i + 1 }))
    }
    if (secteurItem.validOptions.maxLuggage) {
          this.lggSliderPptions.stepsArray = Array.from({ length: secteurItem.validOptions.maxLuggage }, (_, i) => ({ value: i + 1 }))
    }
        secteurItem.validOptions={...secteurItem.validOptions,"isSurf": true,
        "isGolf": true,
        "isBicycle": true,
        "isDog": true,
        "isHandicapped": true}
        secteurItem

    // alert('Secteur Item ==> ' + JSON.stringify(secteurItem, null, 2));    
    if(secteurItem?.taxis){
      console.log('AVAILABLE TYPES ==> ', secteurItem.taxis); 
          secteurItem.taxis = secteurItem.taxis
    }



    //If null or empty object we cancel logic
    if (
      !secteurItem ||
      !secteurItem?.success ||
      !Object.keys(secteurItem)?.length
    ) {
      return;
    }

    console.log('FINAL RESULT ===> ', secteurItem);
    this.selectedSecteur = secteurItem;
    this.quotaItem = secteurItem;
    this.buildCalculePriceForm(secteurItem);
    // alert(this.selectedSecteurForm.get('type')?.value);

    this.calculatePriceForm.updateValueAndValidity();

    this.calculateAllTTC();
    this.locations = [];
    let invalid = [];
    let controls = this.calculatePriceForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log('INVALID ==> ', invalid);
    console.log({ loading: this.isLoading, orderLoading: this.orderLoading });
  }

  onQtyUpdate(increment: boolean) {
    let value = +this.secondStepForm.get('qty')?.value + (increment ? 1 : -1);

    this.secondStepForm.get('qty')?.setValue(value);

    this.secondStepForm.updateValueAndValidity();

    this.pricingControl.setValue(true);
  }

  onLuggageUpdate(increment: boolean) {
    let value = +this.secondStepForm.get('luggage')?.value + (increment ? 1 : -1);

    this.secondStepForm.get('luggage')?.setValue(value);

    this.secondStepForm.updateValueAndValidity();

    this.pricingControl.setValue(true);
  }
  returnTotalQty() {
    let total =
      this.adultPassengersFormArray.getRawValue().length +
      this.childrenPassengersFormArray.getRawValue().length +
      this.babiesPassengersFormArray.getRawValue().length;
    return total;
  }

  selectedSecteur :any= null;
  quotaItem :any= null;

  // async selectedLocation(
  //   event: MatAutocompleteSelectedEvent,
  //   target: 1 | 2 = 2
  // ): Promise<void> {
  //   let value = event.option.value;

  //   console.log('SELECTED LOCATION VALUE ==> ', value);
  //   console.log('SELECTED LOCATION MODE ==> ', target);
  //   console.log('GOOGLE MODE --> ', this.googleMode);
  //   if(value.onlineTitle){
  //     this.executeDepartLogic(value.onlineTitle)

  //     return;
  //   }
  //   let form = this.selectedSecteurForm.getRawValue();
  //   console.log('FORM --> ', form);

  //   const geocoder = new google.maps.Geocoder();
  //   let zoneName = '';
  //   let city = '';
  //   let locality = '';
  //   let place_id = value.place_id;

  //   let { lat, lng }: any = await new Promise(async (resolve) => {
  //     geocoder.geocode(
  //       { placeId: value.place_id, region: 'ma' },
  //       async function (results:any, status:any) {
  //         if (status == 'OK') {
  //           console.log('RESULTS ==> ', results);
  //           let result = results[0];
  //           let lat = results[0]?.geometry?.location?.lat() ?? 0;
  //           let lng = results[0]?.geometry?.location?.lng() ?? 0;
  //           console.log('LAT LONG ==> ', { lat, lng });
  //           console.log('RESULT ====> ', result);

  //           place_id = result.place_id;

  //           resolve({ lat, lng });
  //         } else {
  //           // alert(
  //           //   'Geocode was not successful for the following reason: ' + status
  //           // );
  //           resolve({ lat: 0, lng: 0 });
  //         }
  //       }
  //     );
  //   });

  //   console.log('RESOLVED LAT LNG ===> ', { lat, lng });

  //   if (!lat || !lng) {
  //     return;
  //   }

  //   //! Make sure destination fields are full before proceeding
  //   if (target === 1) {
  //     console.log('TARGET 1', value);
  //     this.selectedSecteurForm.patchValue({
  //       initial_place_id: place_id,
  //       initialLat: lat,
  //       initialLng: lng,
  //       initialAddress: value.description ?? '',
  //       depart: { title: value.description ?? '' },
  //     });
  //     if (
  //       !form?.destination_place_id ||
  //       !form?.destinationLat ||
  //       !form?.destinationLng
  //     ) {
  //       return;
  //     }
  //   }
  //   //! Make sure destination fields are full before proceeding
  //   else if (target === 2) {
  //     console.log('TARGET 2', value);
  //     this.selectedSecteurForm.patchValue({
  //       destination_place_id: place_id,
  //       destinationLat: lat,
  //       destinationLng: lng,
  //       destinationAddress: value.description ?? value.title??'',
  //       destination: { title: value.description?? value.title ?? '' },
  //     });
  //     if (!form?.initial_place_id || !form?.initialLat || !form?.initialLng) {
  //       return;
  //     }
  //   }

  //   await this.updatePrice();

  //   console.log(
  //     'SELECTED SECTEUR FORM VAL ==> ',
  //     this.selectedSecteurForm.getRawValue()
  //   );

  //   // Mark for check
  //   this._changeDetectorRef.markForCheck();
  // }

  async popularSelectedLocation(data:any) {
    this.googleMode = false;
    let value: any = { option: { value: data } };
    this.selectedSecteurForm.get('destination')?.setValue(data);
    await this.selectedLocation(value);
  }

  async selectedRetailer(event:any): Promise<void> {
    try {
      this.isLoading = true;
      let value = event.value;
      console.log('SELECTED RETAILER --> ', value);
      console.log('RETAILERS --> ', this.retailesObjects);  
      let filteredRetailers = this.retailesObjects.filter((retailer:any)=>retailer.retailerId==value);
      console.log('FILTERED RETAILERS --> ', filteredRetailers);
      if(filteredRetailers.length===0){
        console.log('No matching retailer found');
        this.isLoading = false;
        return;
      }

      this.selectedLocation({option:{value:filteredRetailers[0]}}, 1);
      // let retailer:any = this.retailers.find(
      //   (element:any) => element.retailerId === value
      // );
      // console.log('RETAILER FOUND --> ', retailer);
      // if (retailer?.onlineTitle) {
      //   this.resetEverything();
      //   await this.executeDepartLogic(retailer?.onlineTitle);
      // }
      this.isLoading = false;
      // Mark for check
      this._changeDetectorRef.markForCheck();
    } catch (err) {
      console.log('SELECT RETAILER ERR --> ', err);
      this.isLoading = false;
    }
  }

  /**
   * Apply settings based on input
   */
  async executeDepartLogic(retailer: any) {
    try {
      console.log('EXECUTE DEPART LOGIC ---> ', retailer);
      let res = null;

     
        res = await lastValueFrom(
          this._orderService.getDepart(retailer)
        );
      

      console.log('FETCH DEPART 1 ===> ', res);

      this.extraOptions = res;
      this.settings = res;

      if (res.status) {

        console.log('LUGG SLIDER AFTER --> ', this.lggSliderPptions);

        this.firstStepForm.patchValue({
          depart: res.displayTitle,
          initialLat: res.lat ?? 0,
          initialAddress: res.displayTitle ?? '',
          initialLng: res.lng ?? 0,
          initial_place_id: res.place_id ?? '',
        });
        // this.departControl.setValue(res.displayTitle ?? 'no-title');
        //           lastValueFrom(
        //             this._orderService.getPopularAddresses(this.currentRetailerId)
        //           )
        //             .then((res) => {
        //               console.log('FETCH POPULAR ADDRESSES RES --> ', res);
        //               this.secteursFetchingLoading = false;
        //               // Mark for check
        //               // this._changeDetectorRef.markForCheck();
        //             })
        //             .catch((err) => {
        //               console.log('FETCH POPULAR ADDRESSES ERR --> ', err);
        //               this.secteursFetchingLoading = false;
        //               // Mark for check
        //               // this._changeDetectorRef.markForCheck();
        //             });

        // Mark for check
        this._changeDetectorRef.markForCheck();
      } else {
        this._orderService._settings.next(null);
        this.departFound = false;

        this.qtySliderPptions.stepsArray = [];
        this.lggSliderPptions.stepsArray = [];

        this.selectedSecteurForm.patchValue({
          initialSecteur: '',
          depart: '',
          initialLat: 0,
          initialLng: 0,
          initial_place_id: '',
        });
        this.departControl.setValue('');
        this.qtySliderPptions.stepsArray = [];
        this.lggSliderPptions.stepsArray = [];

        // Mark for check
        this._changeDetectorRef.markForCheck();
      }
      console.log('FORM AFTER --> ', this.selectedSecteurForm?.getRawValue());
    } catch (err) {
      console.log('ERROR EXECUTE DEPART LOGIC --> ', err);
    }
  }

  openCGU() {
    const dialogRef = this.dialog.open(TermsCGUDialog, {
      // width: "250px",
      // height: "250px",
      data: { msgType: '', message: '' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('DOALOG CLOSED RESULT ===> ', result);
    });
  }

  openPolicy() {
    const dialogRef = this.dialog.open(TermsPolicyDialog, {
      // width: "250px",
      // height: "250px",
      data: { msgType: '', message: '' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('DOALOG CLOSED RESULT ===> ', result);
    });
  }

  /**
   * Return priceTag dynamically based on settings
   * @param {Moment} customTime
   * @returns
   */
  returnPriceTag(customTime:any = null): Promise<any> {
    return new Promise(async (resolve) => {
      console.log('CUSTOM TIME ===> ', customTime);
      let newDate = new Date();
      let priceTag = '';
      let format = 'hh:mm:ss';
      let time = null,
        beforeTime = null,
        afterTime = null;

      //? Retrieve current city settings
      let settings = this.extraOptions;
      console.log('DATE SETTINGS ==> ', settings?.datesPricing);
      //? Check existence of datesPricing
      if (settings?.datesPricing?.length) {
        //? Iterate and find appropriate date range
let i = 0;
let priceTag = '';

while (i < settings?.datesPricing?.length) {
  // Convertir newDate en Date
  const dateObj = new Date(newDate);
  const date = this.myMoment.tz(dateObj); // applique le fuseau

  console.log('DATE BEFORE ==> ', date.toISOString());

  // Mise à jour de l'heure si customTime
  if (customTime) {
    const [hour, minute] = customTime.split(':').map(Number);
    date.setHours(hour, minute, 0, 0);
  }

  console.log('DATE AFTER ==> ', date.toISOString());

  // Les mois commencent à 0 en JS
  const startMonth = +(settings?.datesPricing[i]?.startMonth - 1);
  const endMonth = +(settings?.datesPricing[i]?.endMonth - 1);

  const currentMonth = date.getMonth();

  // Début et fin de mois
  let startDate = this.myMoment.startOfMonth(
    this.myMoment.tz(new Date(date.getFullYear(), startMonth, 1))
  );
  let endDate = this.myMoment.startOfMonth(
    this.myMoment.tz(new Date(date.getFullYear(), endMonth, 1))
  );

  // Gestion année croisée
  if (startMonth > endMonth) {
    if (currentMonth < endMonth) {
      startDate = this.myMoment.startOfMonth(
        this.myMoment.tz(new Date(date.getFullYear() - 1, startMonth, 1))
      );
    } else {
      endDate = this.myMoment.startOfMonth(
        this.myMoment.tz(new Date(date.getFullYear() + 1, endMonth, 1))
      );
    }
  }

  console.log({
    date: date.toISOString(),
    startMonth,
    currentMonth,
    endMonth,
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  });

  // Premier check : date entre startDate et endDate
  if (date >= startDate && date <= endDate) {
    console.log('IS BETWEEN DATE', {
      startMonth,
      endMonth,
      dateMonth: date.getMonth(),
      date: date.toISOString(),
      start: startDate.toISOString(),
      end: endDate.toISOString(),
    });

    const dayTime = settings?.datesPricing[i].dayTime;
    const nightTime = settings?.datesPricing[i].nightTime;

    const [dayHour, dayMin] = dayTime?.split(':').map(Number);
    const [nightHour, nightMin] = nightTime?.split(':').map(Number);

    const beforeTime = new Date(date);
    beforeTime.setHours(dayHour, dayMin, 0, 0);

    const afterTime = new Date(date);
    afterTime.setHours(nightHour, nightMin, 0, 0);

    console.log({
      beforeTime: beforeTime.toISOString(),
      afterTime: afterTime.toISOString(),
    });

    // Second check : heure entre beforeTime et afterTime
    if (date >= beforeTime && date <= afterTime) {
      console.log('IS BETWEEN TIME');
      priceTag = 'morningPrice';
      break;
    } else {
      console.log('IS NOT BETWEEN TIME');
      priceTag = 'nightPrice';
    }
  }

  i++;
}


      }
      // else {
      //   let dates = settings?.defaultDatespricing ?? [];
      // }
      return resolve(priceTag);
    });
  }

  routerToMaintenance() {
    this._router.navigateByUrl('/maintenance');
  }

  buildFormControl(
    data: {
      ht: number;
      tva: number;
      price: number;
      type: 1 | 2;
      isNight: boolean;
      qty: number;
      luggage: number;
      distance: number;
      duration: number;
    } | null
  ) {
    console.log('BUILD FORM CONTROL --> ', data);

    this.selectedSecteurForm.patchValue({
      ht: data?.ht ?? 0,
      luggage: data?.luggage ?? 1,
      ttc: data?.price ?? 0,
      tva: data?.tva ?? 0,
      price: data?.price ?? 0,
      isNight: data?.isNight ?? false,
      qty: data?.qty ?? 1,
      type: data?.type ? +data.type : 1,
      distance: data?.distance ?? 0,
      duration: data?.duration ?? 0,
    });
  }

  /**
   * Open confirmation dialog
   */
  openConfirmationDialog(
    configForm:any,
    action = false,
    okCallBack = () => {},
    noCallBack = () => {}
  ): void {
    // Open the dialog and save the reference of it

    const dialogRef = this._fuseConfirmationService.open(configForm.value);

    // Subscribe to afterClosed from the dialog reference
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('DIALOG RESULT ---> ', result);
      if (result === 'confirmed' && action) {
        okCallBack();
      }
    });
  }
 /**
   * Open confirmation dialog
   */
  openConfirmationDialogInTimeOut(
    configForm:any,
    action = true,
    okCallBack = () => {},
    noCallBack = () => {}
  ): void {
    // Open the dialog and save the reference of it

    const dialogRef = this._fuseConfirmationService.open(configForm.value);

    // Subscribe to afterClosed from the dialog reference
    dialogRef.afterClosed().subscribe((result:any) => {
      console.log('DIALOG RESULT ---> ', result);
      if (result === 'confirmed' && action) {
        okCallBack();
      }
    });
  }
  get selectedType() {
    return this.selectedSecteurForm.get('type')?.value;
  }
  buildForm(
    title: string = 'Error',
    message: string = 'An unknown error occured!',
    icon :any= 'heroicons_outline:exclamation',
    isCancel: boolean = false 
  ) {
    let form = this._formBuilder.group({
      title: title,
      message: ` <span class="font-medium">${message}</span>`,
      icon: this._formBuilder.group({
        show: true,
        name: icon,
        color: 'primary',
      }),
      actions: this._formBuilder.group({
        confirm: this._formBuilder.group({
          show: true,
          label: 'Okay',
          color: 'accent',
        }),
        cancel: this._formBuilder.group({
          show: isCancel,
          label: 'cancel',
          color: 'accent',
        }),
      }),
      dismissible: false,
    });
    return form;
  }

  coords11:any;

  coords22:any;


  async googleMapsPointInsidePoly1(point:any) {
    return new Promise((resolve, reject) => {
      let isWithinPolygon1 = google.maps.geometry.poly.containsLocation(
        new google.maps.LatLng(point.lat, point.lng),
        new google.maps.Polygon({
          paths: this.coords11,
        })
      );
      resolve(isWithinPolygon1);
    });
  }

  googleMapsPointInsidePolygon(point:any, polygon:any, title:any) {
    return new Promise((resolve, reject) => {
      let isWithinPolygon2 = google.maps.geometry.poly.containsLocation(
        new google.maps.LatLng(+point.lat, +point.lng),
        new google.maps.Polygon({
          paths: polygon,
        })
      );
      console.log('Polygon Title ==> ', title);
      console.log('isWithinPolygon ==> ', isWithinPolygon2);
      resolve(isWithinPolygon2);
    });
  }

  googleMapsPointInsidePoly2(point:any) {
    return new Promise((resolve, reject) => {
      let isWithinPolygon2 = google.maps.geometry.poly.containsLocation(
        new google.maps.LatLng(+point.lat, +point.lng),
        new google.maps.Polygon({
          paths: this.coords22,
        })
      );
      resolve(isWithinPolygon2);
    });
  }
    isChecked(index:number):boolean {
      return this.selectedSecteurForm.get('paymentMode')?.value === index ;
    }
  //? Payment mode selection
   //? Payment mode selection
  async onSelect(value: any) {

    if(value===3 &&(this.walletInfo?.solde <= 0 ||(this.walletInfo?.solde > 0 &&this.walletInfo?.solde < this.totalPriceTTC))){
        return;
    }
    console.log('PAYMENT MODE SELECTED --> ', value);
    let index = this.paymentModes.findIndex((item) => item.id === value);
    if (index > -1) {
      this.selectedSecteurForm.patchValue({ paymentMode: value });
    }   
    console.log('SELECTED mode value VAL ==> ', this.selectedSecteurForm.get('paymentMode')?.value);

    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  toggleIsNightDisplay() {
    if (this.selectedSecteurForm.get('isNight')?.value) {
      this.displayNightText = !this.displayNightText;
    }
  }
  async qtySliderChange(event:any) {
    console.log('QTY SLIDER CHANGE ==> ', { event });
    let qty = event.value ?? 0;
    console.log('QTY VAL ===> ', qty);
    this.secondStepForm.get('qty')?.setValue(qty);
    // this.calculateAllTTC();
    this.pricingControl.setValue(true);
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  async lggSliderChange(event:any) {
    console.log('LGG SLIDER CHANGE ==> ', { event });
    let luggage = event.value ?? 0;
    console.log('LUGGAGE VAL ===> ', luggage);

    this.secondStepForm.get('luggage')?.setValue(luggage);

    this.pricingControl.setValue(true);
    //this.calculateAllTTC();
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }
  get isDogControl(): FormControl {
    return this.secondStepForm.get('isDog') as FormControl;
  }

  isDogChange(event:any) {
    let isChecked=this.secondStepForm.get('isDog')?.value;
    this.secondStepForm.get('isDog')?.setValue(!isChecked);
    console.log('IS DOG VAL ===> ', this.isDogControl.value);
    this.calculateAllTTC();
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }
  get isSurfControl(): FormControl {
    return this.secondStepForm.get('isSurf') as FormControl;
  }
  isSurfChange(event:any) {
   let isChecked=this.secondStepForm.get('isSurf')?.value;
    this.secondStepForm.get('isSurf')?.setValue(!isChecked);
    this.calculateAllTTC();
  }

  get isGolfControl(): FormControl {
    return this.secondStepForm.get('isGolf') as FormControl;
  }
  isGolfChange(event:any) {
    let isChecked=this.secondStepForm.get('isGolf')?.value;
    this.secondStepForm.get('isGolf')?.setValue(!isChecked);
    this.calculateAllTTC();
  }

  get isBicycleControl(): FormControl {
    return this.secondStepForm.get('isBicycle') as FormControl;
  }
  isBicycleChange(event:any) {
    let isChecked=this.secondStepForm.get('isBicycle')?.value;
    this.secondStepForm.get('isBicycle')?.setValue(!isChecked);
    this.calculateAllTTC();
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  get isHandicappedControl(): FormControl {
    return this.secondStepForm.get('isHandicapped') as FormControl;
  }
  isHandicappedChange(event:any) {
    let isChecked=this.secondStepForm.get('isHandicapped')?.value;
    this.secondStepForm.get('isHandicapped')?.setValue(!isChecked);
    this.calculateAllTTC();
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  /**
   * When to display night tarif notification only when there is a difference between day and night price
   */
  ifDisplayNightTarif: boolean = false;

  checkIfDisplayNightTarif() {
    try {
      let isNight = this.selectedSecteurForm.get('isNight')?.value ?? false;
      // No need to check anything if already not in night mode
      if (!isNight) {
        return;
      }

      let taxis = [],
        retourVehics = [],
        retour = false,
        type = 0;

      taxis =
        this.selectedSecteurForm.get('taxis')?.value ?? [];
      retourVehics = this.selectedSecteurForm.get('retourVehics')?.value ?? [];
      type = this.selectedSecteurForm.get('type')?.value ?? 0;
      retour = this.selectedSecteurForm.get('retour')?.value ?? false;

      console.log(' checkIfDisplayNightTarif => ', {
        taxis,
        retourVehics,
        type,
        retour,
      });

      if (taxis?.length && !retour && type) {
        let morningPrice = 0,
          nightPrice = 0;

        morningPrice =
          taxis.find((item:any) => item.taxiType == type)['morningPrice'] ?? 0;
        nightPrice =
          taxis.find((item:any) => item.taxiType == type)['nightPrice'] ?? 0;

        console.log('MORNING PRICE _-> ', { morningPrice, nightPrice });

        if (morningPrice && nightPrice && morningPrice !== nightPrice) {
          this.ifDisplayNightTarif = true;
        }
      } else if (retourVehics?.length && retour && type) {
        let morningPrice = 0,
          nightPrice = 0;

        morningPrice =
          retourVehics.find((item:any) => item.id == type)['morningPrice'] ?? 0;
        nightPrice =
          retourVehics.find((item:any) => item.id == type)['nightPrice'] ?? 0;

        if (morningPrice && nightPrice && morningPrice !== nightPrice) {
          this.ifDisplayNightTarif = true;
        }
      }
      console.log(
        ' checkIfDisplayNightTarif Res ==> ',
        this.ifDisplayNightTarif
      );
    } catch (err) {
      console.log('checkIfDisplayNightTarif Err -> ', err);
    }
  }

  currentRetourVehics = [];

  async toggleRetour() {
    let retourMode = this.selectedSecteurForm.get('retour')?.value;
    if (!retourMode) {
      console.log('--------- 1 ----------');
      this.selectedSecteurForm.patchValue({
        aller: false,
        retour: true,
      });
      this.eventForm1.get('retourName')?.setValidators([Validators.required]);
      this.eventForm1.get('retourPhone')?.setValidators([Validators.required]);
      // this.eventForm1
      //   .get('retourVehics')
      //   .setValidators([Validators.required]);
      this.eventForm1.get('retourName')?.updateValueAndValidity();
      this.eventForm1.get('retourPhone')?.updateValueAndValidity();

      //!If secteur already selected we switch to usage of retourVehics for pricing
      //? We check secteur already selected by checking taxis
      let retourVehics =
        this.selectedSecteurForm.get('retourVehics')?.value ?? [];
      if (
        this.selectedSecteurForm.get('taxis')?.value?.length &&
        retourVehics?.length
      ) {
        let secteurItem: any = {};
        let priceTag = await this.returnPriceTag(
          this.selectedSecteurForm.get('time')?.value
        );

        let forcedType = 0;

        if (retourVehics?.length === 1) {
          forcedType = retourVehics[0].taxiType;
        }

        let previousVal = this.selectedSecteurForm.getRawValue();

        secteurItem = {
          _id: nanoid(8),
          tva: previousVal.tva ?? 3.96,
          taxis:
            this.selectedSecteurForm.get('taxis')?.value,
          retourVehics: retourVehics,
          availableTypes: this.selectedSecteurForm
            .get('taxis')
            ?.value.map((vehic:any) => vehic.taxiType),
          retourVehicsTypes: retourVehics?.map((vehic:any) => vehic.taxiType),
          secteurId: previousVal.secteurId,
          price: retourVehics[0][priceTag],
          type: retourVehics[0].taxiType,
          forcedType,
          qty: 1,
          zoneName: 'ZONE',
          secteur: previousVal.secteur ?? '',
          secteurLng: previousVal.secteurLng ?? '',
          extra: '',
          lat: previousVal.lat ?? 0,
          lng: previousVal.lng ?? 0,
          place_id: previousVal.place_id ?? '',
          priceTag,
          isNight: priceTag == 'nightPrice' ? true : false,
          aller: false,
          retour: true,
        };

        if (this.selectedSecteurForm.get('taxis')?.value?.length) {
          let secteurItem: any = {};
          let priceTag = await this.returnPriceTag(
            this.selectedSecteurForm.get('time')?.value
          );

          let forcedType = 0;

          let taxis =
            this.selectedSecteurForm.get('taxis')?.value ?? [];

          if (taxis?.length === 1) {
            forcedType = taxis[0].taxiType;
          }

          let previousVal = this.selectedSecteurForm.getRawValue();

          secteurItem = {
            _id: nanoid(8),
            tva: previousVal.tva ?? 3.96,
            taxis: taxis,
            availableTypes: taxis?.map((vehic:any) => vehic.taxiType),
            retourVehics: previousVal.retourVehics ?? [],
            retourVehicsTypes: previousVal.retourVehics?.map(
              (vehic:any) => vehic.taxiType
            ),
            secteurId: previousVal.secteurId,
            price: taxis[0][priceTag],
            type: taxis[0].taxiType,
            forcedType,
            qty: 1,
            zoneName: 'ZONE',
            secteur: previousVal.secteur ?? '',
            secteurLng: previousVal.secteurLng ?? '',
            extra: '',
            lat: previousVal.lat ?? 0,
            lng: previousVal.lng ?? 0,
            place_id: previousVal.place_id ?? '',
            priceTag,
            isNight: priceTag == 'nightPrice' ? true : false,
            aller: false,
            retour: true,
          };

          let res = this.extraOptions?.retourTypes?.find(
            (item:any) => item.taxiType == previousVal.type
          );
          console.log('FINDED RETOUR TYPE ==> ', res);
          if (res) {
            this.selectedSecteurForm.patchValue({
              type: 2,
              qty: previousVal.qty > res.maxQty ? res.maxQty : previousVal.qty,
              luggage:
                previousVal.luggage > res.maxLuggage
                  ? res.maxLuggage
                  : previousVal.luggage,
              price: secteurItem.price,
              ht: secteurItem.price,
              ttc: ((secteurItem.price ?? 0) + secteurItem.tva)?.toFixed(2),
              tva: secteurItem.tva,
            });

            this.qtySliderValue =
              this.secondStepForm.get('qty')?.value ?? 1;
            this.lggSliderValue =
              this.secondStepForm.get('luggage')?.value ?? 1;

            this.qtySliderPptions = {
              showTicksValues: true,
              stepsArray: this.extraOptions.qtySlider?.filter(
                (item:any) => item.value <= res.maxQty
              ),
            };
            this.lggSliderPptions = {
              showTicksValues: true,
              stepsArray: this.extraOptions.luggageSlider?.filter(
                (item:any) => item.value <= res.maxLuggage
              ),
            };
            console.log('NEW QTY ARRAY =+> ', this.qtySliderPptions.stepsArray);
            console.log('NEW LUG ARRAY =+> ', this.lggSliderPptions.stepsArray);
            // Mark for check
            this._changeDetectorRef.markForCheck();
          }

          this.selectedSecteur = secteurItem;
          this.quotaItem = secteurItem;
          this.buildFormControl(secteurItem);
          this.selectedSecteurForm.updateValueAndValidity();
          this.calculateAllTTC();
          // Mark for check
          this._changeDetectorRef.markForCheck();
        }

        this.selectedSecteur = secteurItem;
        this.quotaItem = secteurItem;
        this.buildFormControl(secteurItem);
        this.selectedSecteurForm.updateValueAndValidity();
        this.calculateAllTTC();
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }
    } else {
      console.log('--------- 2 ----------');
      this.selectedSecteurForm.patchValue({
        aller: true,
        retour: false,
      });
      this.eventForm1.get('retourName')?.clearValidators();
      this.eventForm1.get('retourPhone')?.clearValidators();
      this.selectedSecteurForm.get('retourVehics')?.clearValidators();
      this.eventForm1.get('retourName')?.updateValueAndValidity();
      this.eventForm1.get('retourPhone')?.updateValueAndValidity();

      let retourVehics =
        this.selectedSecteurForm.get('retourVehics')?.value ?? [];
      if (
        this.selectedSecteurForm.get('taxis')?.value?.length &&
        retourVehics?.length
      ) {
        if (this.selectedSecteurForm.get('taxis')?.value?.length) {
          let secteurItem: any = {};
          let priceTag = await this.returnPriceTag(
            this.selectedSecteurForm.get('time')?.value
          );

          let forcedType = 0;

          let taxis =
            this.selectedSecteurForm.get('taxis')?.value ?? [];

          if (taxis?.length === 1) {
            forcedType = taxis[0].taxiType;
          }

          let previousVal = this.selectedSecteurForm.getRawValue();

          secteurItem = {
            _id: nanoid(8),
            tva: previousVal.tva ?? 3.96,
            taxis: taxis,
            availableTypes: taxis?.map((vehic:any) => vehic.taxiType),
            retourVehics: previousVal.retourVehics ?? [],
            retourVehicsTypes: previousVal.retourVehics?.map(
              (vehic:any) => vehic.taxiType
            ),
            secteurId: previousVal.secteurId,
            price: taxis[0][priceTag],
            type: taxis[0].taxiType,
            forcedType,
            qty: 1,
            luggage: 1,
            zoneName: 'ZONE',
            secteur: previousVal.secteur ?? '',
            secteurLng: previousVal.secteurLng ?? '',
            extra: '',
            lat: previousVal.lat ?? 0,
            lng: previousVal.lng ?? 0,
            place_id: previousVal.place_id ?? '',
            priceTag,
            isNight: priceTag == 'nightPrice' ? true : false,
            aller: false,
            retour: true,
          };

          this.selectedSecteur = secteurItem;
          this.quotaItem = secteurItem;
          this.buildFormControl(secteurItem);
          this.selectedSecteurForm.updateValueAndValidity();
          this.calculateAllTTC();
          // Mark for check
          this._changeDetectorRef.markForCheck();
        }

        // Mark for check
        this._changeDetectorRef.markForCheck();
      }

      this.qtySliderPptions = {
        showTicksValues: true,
        stepsArray: this.extraOptions.qtySlider,
      };
      this.lggSliderPptions = {
        showTicksValues: true,
        stepsArray: this.extraOptions.luggageSlider,
      };
    }
    let invalid = [];
    let controls = this.selectedSecteurForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log('INVALID ==> ', invalid);
    console.log(
      'FORM AFTER TOGGLE ==> ',
      this.selectedSecteurForm.getRawValue()
    );
  }

  returnSecteurItem(data:any) {
console.log('RETURN SECTEUR ITEM ==> ', data);

let secteurItem = null;
let priceTag = '';

// Récupérer l'heure depuis le formulaire ou prendre maintenant
const formTime = this.selectedSecteurForm.get('time')?.value;
let currentTime: Date;

if (formTime) {
  // formTime = "HH:mm"
  const [hour, minute] = formTime.split(':').map(Number);
  currentTime = new Date();
  currentTime.setHours(hour, minute, 0, 0);
} else {
  currentTime = new Date();
}

// Appliquer le fuseau horaire via mini-moment
const time = this.myMoment.tz(currentTime);

// Définir beforeTime et afterTime (06:00 et 21:00)
const beforeTime = new Date(time);
beforeTime.setHours(6, 0, 0, 0);

const afterTime = new Date(time);
afterTime.setHours(21, 0, 0, 0);

// Vérifier si l'heure est entre beforeTime et afterTime
if (time >= beforeTime && time <= afterTime) {
  priceTag = 'morningPrice';
} else {
  priceTag = 'nightPrice';
}

console.log('priceTag ==> ', priceTag);

    if (data.km < 3) {
      let taxis :any[]= [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 100,
          nightPrice: 150,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 100,
          nightPrice: 150,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis: taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 5,
      };
    } else if (data.km >= 3 && data.km < 5) {
      let taxis:any[] = [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 110,
          nightPrice: 165,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 110,
          nightPrice: 165,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis: taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 6,
      };
    } else if (data.km >= 5 && data.km < 7) {
      let taxis:any[] = [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 120,
          nightPrice: 180,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 120,
          nightPrice: 180,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 7,
      };
    } else if (data.km >= 7 && data.km < 9) {
      let taxis:any[]= [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 130,
          nightPrice: 195,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 130,
          nightPrice: 195,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 8,
      };
    } else if (data.km >= 9 && data.km < 11) {
      let taxis :any[]= [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 140,
          nightPrice: 210,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 140,
          nightPrice: 210,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 9,
      };
    } else if (data.km >= 11 && data.km < 13) {
      let taxis :any[]= [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 150,
          nightPrice: 225,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 150,
          nightPrice: 225,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 10,
      };
    } else if (data.km >= 13 && data.km < 15) {
      let taxis :any[]= [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 160,
          nightPrice: 240,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 160,
          nightPrice: 240,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 11,
      };
    } else if (data.km >= 15 && data.km < 20) {
      let taxis: any[] = [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 250,
          nightPrice: 250,
        },
        {
          id: 2,
          title: 'Small taxi',
          morningPrice: 250,
          nightPrice: 250,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis,
        availableTypes: taxis?.map((vehic:any) => vehic.id),
        price: taxis[0][priceTag],
        secteur: data.main_text ?? '',
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 11,
      };
    } else if (data.km >= 20 && data.km < 25) {
      let taxis = [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 300,
          nightPrice: 300,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis: taxis,
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 10,
      };
    } else if (data.km >= 25 && data.km < 30) {
      let taxis = [
        {
          id: 1,
          title: 'Big taxi',
          morningPrice: 350,
          nightPrice: 350,
        },
      ];

      secteurItem = {
        _id: nanoid(8),
        title: data.main_text ?? '',
        en: data.main_text ?? '',
        fr: data.main_text ?? '',
        ar: data.main_text ?? '',
        extra: data.main_text ?? '',
        taxis: taxis,
        zoneName: 'مراكش',
        place_id: data.place_id,
        outside: false,
        loc: {
          type: 'Point',
          coordinates: [data.lng, data.lat],
        },
        km: data.km ?? 0,
        lat: data.lat,
        lng: data.lng,
        tva: 10,
      };
    } else {
      return null;
    }

    return secteurItem;
  }

  toggleDriverData(data:any) {
    console.log('TOGGLE DRIVER DATA', data);
    this.selectedSecteurForm.patchValue({ driverId: data });
  }

  toggleAffect() {
    console.log('TOGGLE AFFECT MODE');
    this.selectedSecteurForm.patchValue({ affect: true });
  }

  /**
   * Will generate a proper topup amount for the client to use
   */
  fetchTopUpUrl() {
    try {
      let requiredAmount = this.totalPriceTTC ?? 0;
      let currentBalance = this.walletInfo?.solde ?? 0;
      const options = this.suggestTopupOptions(requiredAmount, currentBalance);
      if (!options) {
        return;
      }

      console.log('SUGGESTIONS ---> ', options);

      this.openTopupDialog(options);
    } catch (err) {}
  }

  suggestTopupOptions(requiredAmount: number, currentBalance: number = 0) {
    if (!requiredAmount) {
      return null;
    }
    const missingAmount = Math.max(requiredAmount - currentBalance, 10); // Minimum 10

    // 1. Minimum option (exact missing, rounded to nearest 10)
    const minOption = Math.ceil(missingAmount / 10) * 10;

    // 2. Upsell option (minimum +25%, rounded to nearest 50)
    let upsellOption = Math.ceil((minOption * 1.25) / 50) * 50;

    // 3. Balanced option (midpoint between min and upsell, rounded)
    let balancedOption = Math.ceil((minOption + upsellOption) / 2 / 10) * 10;

    // Ensure all options are unique
    const options = new Set([minOption, balancedOption, upsellOption]);

    // If duplicates exist, increase upsell by 50 until unique
    while (options.size < 3) {
      upsellOption += 50;
      balancedOption = Math.ceil((minOption + upsellOption) / 2 / 10) * 10;
      options.add(upsellOption).add(balancedOption);
    }

    // Return as sorted array (small → large)
    return Array.from(options)
      .sort((a, b) => a - b)
      ?.slice(0, 3);
  }

  openTopupDialog(options:any) {
    const dialogRef = this.dialog.open(TopUpDialogComponent, {
      // width: "250px",
      // height: "250px",
      data: { value: options },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      try {
        console.log('DIALOG CLOSED RESULT ===> ', result);
        if (result?.success && result?.amount) {
          this._splashScreenService.show();
          // Mark for check
          this._changeDetectorRef.markForCheck();
          this.isLoading = true;
          let topupRes:any = await lastValueFrom(
            this._userservice.increaseWallet({
              reqType: 3,
              amount: result.amount ?? 0,
            })
          );
          console.log('TOPUP RES ---> ', topupRes);
          //! Now we execute CMI logic
          if (topupRes?.success) {
            let cmiBody = {
              cstmPass: 'booking',
              ref: topupRes.ref ?? '',
              
              amount: result.amount,
              secteurValue: { ref: topupRes.ref ?? '', amount: result.amount },
            };
            let cmiData = await lastValueFrom(
              this._userservice.fetchCmiData(cmiBody)
            );
            console.log('CMI DATA ---> ', cmiData);
            if (cmiData) {
              this.cmiFormSubmit(cmiData);
            } else {
              this.isLoading = false;
              this._splashScreenService.hide();
            }
          } else {
            this.isLoading = false;
            this._splashScreenService.hide();
          }
        }
        // Mark for check
        this._changeDetectorRef.markForCheck();
      } catch (err) {
        console.log('ERROR ---> ', err);
        this.isLoading = false;
        this._splashScreenService.hide();
        // Mark for check
        this._changeDetectorRef.markForCheck();
      }
    });
  }

  cmiFormSubmit(result:any) {
    this._splashScreenService.show();
    //CMI
    for (let prop in result) {
      const input = this.document.createElement('input');
      input.type = 'text';
      input.name = prop;
      input.hidden = true;
      input.value = result[prop];
      this.testFormElement?.nativeElement.appendChild(input);
    }
    this.testFormElement!.nativeElement!.action =
      'https://payment.cmi.co.ma/fim/est3Dgate';  
    this.testFormElement!.nativeElement!.method = 'POST';


    console.log('FORM ELEMENT ==> ', this.testFormElement);
    this.testFormElement!.nativeElement!.submit();
  }

  // t(mot:string){
  //   return mot;
  // }

  /**
   * Show flash message
   */
  showFlashMessage(type: 'success' | 'error'): void {
    // Show the message
    this.flashMessage = type;

    // Mark for check
    this._changeDetectorRef.markForCheck();

    // Hide it after 3 seconds
    setTimeout(() => {
      this.flashMessage = null;

      // Mark for check
      this._changeDetectorRef.markForCheck();
    }, 3000);
  }

  /**
   * Get country info by iso code
   *
   * @param code
   */
  getCountryByCode(code: any): any {
    if(!code) return null;
    return this.countries.find((country:any) => country.code === code);
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item._id || index;
  }

  displayFn(): (item: any) => string {
    return (item: any): string => {
          console.log('DISPLAY FN', item);

      if (item && item !== '') {
        let des= item && item[this.activeLang]
          ? item[this.activeLang]
          : typeof item === 'string' && item
          ? item
          : item.description
          ? item.description
          : item.displayTitle
          ? item.displayTitle
          : '';
          console.log('DISPLAY FN RES', des);
          return des;
      } else {
        return '';
      }
    };
  }

  displayRetailerFn(): (item: any) => string {
    return (item: any): string => {
      if (item && item !== '') {
        return item?.displayTitle ?? '';
      } else {
        return '';
      }
    };
  }


  isSecondFormValide(){
    console.log('third STEP VALID ==> ', this.thirdStepForm.value,"thirdStepForm invalid", this.thirdStepForm.invalid);
    return this.firstStepForm.valid && this.secondStepForm.valid && this.calculatePriceForm.valid && this.totalPriceToDisplaySignal() > 0 && this.selectedTypeSignal() != 0;
  }

  isSendingOtp = false; 


async sendOtp() {
  let body = {
    phone: this.phone.value,
    country: this.thirdStepForm.get('country')?.value
  };
  console.log('BODY OTP REQUEST ==> ', body);

  if (body && body.phone && body.country) {
    this.isSendingOtp = true; // désactive le bouton
    try {
      let res = await lastValueFrom(this.clientService.requestOtp(body));
      if (res.otpSent) {
        this.startOtpTimer(res.retryAfter)
        this.loungeStepper.next();
      }
    } catch (err) {
      console.log('ERROR OTP REQUEST ==> ', err);
    } finally {
      this.isSendingOtp = false; // réactive le bouton après réponse
    }
  }
}

  

   async passeToPayement(){
    
    if(!this.isSecondFormValide())return;
     this.clearPhoneValidators()
    console.log('IS CLIENT, SKIP OTP REQUEST');

    this.isClient=this.clientService.isLogged();
    if(this.isClient){
      await this.fetchWalletInfo();
       this.paymentSelected(this.totalPriceTTC);
    }
    

     this.loungeStepper.next();

    
  }
  paymentSelected(amount: number) {

   let paymentAmount= (this.walletInfo?.solde >= amount) ? 3 : 4;
   this.selectedSecteurForm.patchValue({ paymentMode: paymentAmount });
  }

  returnToStepOne() {
    this.loungeStepper._steps.forEach(
      (step:any) => ((step.editable = true), (step.completed = false))
    );

    this.loungeStepper.selectedIndex = 0;
    // Mark for check
    this._changeDetectorRef.markForCheck();
  }

  roundTwoDecimals(num:any) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }


    passToPaymentMethod(amount:any) {
  
      this._router.navigate(['/wallet/payment'], { queryParams: { amount } });
    }
    getOptionSelected(): string[] {
      const optionMap: Record<string, string> = {
        isDog: 'COMMON.OPTIONS.PET',
        isGolf: 'COMMON.OPTIONS.GOLF',
        isSurf: 'COMMON.OPTIONS.SURFBOARD', 
        isBicycle: 'COMMON.OPTIONS.BICYCLE',
        isHandicapped: 'COMMON.OPTIONS.WHEELCHAIR'
      };

      const selected = Object.entries(optionMap)
        .filter(([key]) => this.secondStepForm.get(key)?.value === true)
        .map(([_, value]) => value);

      console.log("Options selected =>", selected);
      this._changeDetectorRef.markForCheck();
      return selected;
    }

    async continue2(){
      try {
        if (this.isProcessingPayment()) {
        return;
        }

        this.isProcessingPayment.set(true);
        this._changeDetectorRef.markForCheck();


        let firstStep= this.firstStepForm.getRawValue();
        let secondStep= this.secondStepForm.getRawValue();
        let calculatePriceForm= this.calculatePriceForm.getRawValue();

        let paymentMode= this.selectedSecteurForm.get('paymentMode')?.value;

        let form={...firstStep, ...secondStep,...calculatePriceForm,paymentMode:paymentMode};


        let tripType= form.tripType;

        let forcedType= form.forcedType;

        // if(tripType===3){
        // forcedType=0;
        // }
        //alert("payment mode"+paymentMode)
        console.log('FORM SUBMIT ==> ', form);

        // if(firstStep.invalid&& secondStep.invalid) return;
        console.log('FIRST STEP ==> ', firstStep);
        console.log('SECOND STEP ==> ', secondStep);
    const now = new Date();

    // Add 30 minutes to now
    const nowPlus30 = new Date(now.getTime() + 30 * 60 * 1000);

    // Trip datetime from the form
    const tripTime = new Date(form.date);

          // Compare
    let finalDateTime;

    if (nowPlus30 > tripTime) {
      // If actual time passed trip time → use now + 30 minutes
      finalDateTime = nowPlus30
      this.firstStepForm.get('date')?.setValue(finalDateTime.toISOString(), { emitEvent: false });

      // Extraire l'heure et les minutes au format "HH:mm"
      const hours = finalDateTime.getHours().toString().padStart(2, '0');
      const minutes = finalDateTime.getMinutes().toString().padStart(2, '0');
      const timeString = `${hours}:${minutes}`;
      this.firstStepForm.get('time')?.setValue(timeString);
      finalDateTime=finalDateTime.toISOString()


    } else {
      // Otherwise keep the original trip time
      finalDateTime = tripTime.toISOString();
    }
        // if(!this.payementMethod.some((item) => item === true)) return;
        let user = await lastValueFrom(this._userservice.getUserInfo());
        let body = {
        departure_datetime: finalDateTime,
        time:  this.firstStepForm.get('time')?.value, 
        clientId: user?.userId,
        initial_place_id: form.initial_place_id,
        initialLat: form.initialLat,
        initialLng: form.initialLng,
        initialAddress: form.depart,
        destination_place_id: form.destination_place_id,
        destinationLat: form.destinationLat,
        destinationLng: form.destinationLng,
        destinationAddress: form.destination,
        price: form.price,
        passengersNb: form.qty,
        tripType: form.tripType,
        luggageNb: form.luggage,
        paymentMode: paymentMode,
        retour: true,
        distance: form.distance,
        duration: form.duration,
        forcedType: forcedType || 0,
        isDog: form.isDog,
        isSurf: form.isSurf,
        isGolf: form.isGolf,
        isBicycle: form.isBicycle,
        isHandicapped: form.isHandicapped,
        isOldMedina: form.isOldMedina,
        totalOptions: this.totalPriceOptions,

        };



        console.log('wallet info ==> ', this.walletInfo,"form paymentMode", form.paymentMode);

        if (form.paymentMode === 4) {
        // let user = await lastValueFrom(this._userservice.getUserInfo());
        console.log('USER INFO ==> ', user);
        let bodyCmi = {
        ...body,
        cstmPass: environment.ctmPass,
        amount: form.price,
        };

        // Create a new object with the secteurValue property
        const cmiRequestData = {
        ...bodyCmi,
        secteurValue: { ...bodyCmi },
        };

        console.log('BODY CMI ==> ', cmiRequestData);

        try {
        let CMI = await lastValueFrom(
        this._userservice.passTripByCmi(cmiRequestData)
        );

        console.log('CMI RES ==> ', CMI);
        this.cmiFormSubmit(CMI);
        } catch (err: any) {
        console.log('Error submitting trip:', err.error);
        let title = 'Oops';
        const isActiveTrip = err.error.activeTrip;
        const tripId = err.error.activeTripId;
        let message = err.error.message;
        if (isActiveTrip) {
        message = this.translateService.translateKey('TRIP.ACTIVE_TRIP_EXISTS');
        this.openDialog(
          title,
          message,
          this.infoIcon,
          true,
          async () => {
            console.log('Dialog ok clicked');
            this._orderService
              .cancelTrip(tripId)
              .subscribe(async (res: any) => {
                console.log('CANCEL TRIP RES ==> ', res);
                if (res?.success) {
                  try{
                  this.isProcessingPayment.set(true);

                  let result = await lastValueFrom(
                    this._userservice.passTripByCmi(bodyCmi)
                  );
                  console.log('RESULT PASS TRIP BY CMI ==> ', result);
                  this.cmiFormSubmit(result);

                  // this.successPayment(result);
                  this._changeDetectorRef.markForCheck();
                  this._changeDetectorRef.detectChanges();
                }catch(err){
                  this.isProcessingPayment.set(false);

                }
                } else {
                  this.openDialog(
                    'Error',
                    'Something went wrong while cancelling trip',
                    this.infoIcon
                  );
                }
              });
          },
          () => {
            console.log('Dialog no clicked');
          }
        );
        } else {
        this.openDialog(title, message, this.infoIcon);
        }
        }
        } else {
        if (form.paymentMode === 2 || form.paymentMode === 3) {
        try {
        let result = await lastValueFrom(this._orderService.submitTrip(body));
        console.log('RES SUBMIT TRIP ==> ', result);

        this.successPayment(result);
        } catch (err: any) {
        console.log('Error submitting trip:', err.error);
        let title = 'Oops';
        const isActiveTrip = err.error.activeTrip;
        const tripId = err.error.activeTripId;
        let message = err.error.message;
        if (isActiveTrip) {
        message = this.translateService.translateKey('TRIP.ACTIVE_TRIP_EXISTS');
        this.openDialog(
          title,
          message,
          this.infoIcon,
          true,
          async () => {
            console.log('Dialog ok clicked');
            this._orderService
              .cancelTrip(tripId)
              .subscribe(async (res: any) => {
                console.log('CANCEL TRIP RES ==> ', res);
                if (res?.success) {
                  // this.openDialog('Success', 'Trip cancelled successfully', this.successIcon);
                  let result = await lastValueFrom(
                    this._orderService.submitTrip(body)
                  );
                  this.successPayment(result);
                  this._changeDetectorRef.markForCheck();
                  this._changeDetectorRef.detectChanges();
                } else {
                  this.openDialog(
                    'Error',
                    'Something went wrong while cancelling trip',
                    this.infoIcon
                  );
                }
              });
          },
          () => {
            console.log('Dialog no clicked');
          }
        );
        } else {
        this.openDialog(title, message, this.infoIcon);
        }
        }
        }

        }
        this.isProcessingPayment.set(false);
      }catch(err){
        this.isProcessingPayment.set(false);
        this._changeDetectorRef.markForCheck();
        console.log('ERROR IN CONTINUE TO PAYMENT ==> ', err);
      }
      }


      tripType!:number;
      ticketData:any;
  isNotifyingDrivers = true;
  async successPayment(result: any) {
    if (result?.success) {
      //? Display Dialog with Success message
      let title = 'Success';
      let message = 'Ticket Created Successfully!';
      // this.openDialog(title, message, this.successIcon);
      this.orderLoading = false;
      this._splashScreenService.hide();
      let ticketId = result?.orderId;
      this.ticketId = ticketId;

      localStorage.setItem('currentTicketId', ticketId);

      let trip = await lastValueFrom(this._orderService.fetchTrip(ticketId));
      console.log('TRIP RES ==> ', trip);
      console.log('TRIP RES  type ==> ', trip.ticket.tripType);
      this.tripType = trip.ticket.tripType;
      this.ticketData = trip.ticket;
      
      // alert('Ticket Created Successfully!');

      // alert(this.ticketId + ' ')
     if(!result?.notifyingDrivers){
        console.log('not NOTIFYING DRIVERS');
        this.isNotifyingDrivers = false;
        this.lookingForDrivers = true;
                          // alert('Trip found, waiting for drivers to accept..onInit.');
                this._router.navigate(['ticket-confirmation', this.ticketId], { relativeTo: this.route });

        this._changeDetectorRef.markForCheck();
        
        return;
      }
      // this.currentTripModeSignal = 0;
      
      setTimeout(() => {
        this.lookingForDrivers = true;

        // this._changeDetectorRef.detectChanges();
        // this._changeDetectorRef.markForCheck();

        // Find and click the cash payment option
        const cashElement = document.getElementById('cash');
        if (cashElement) {
          cashElement.click();
        } else {
          // console.error('Cash payment element not found');

          // Alternative approach: try to select the cash payment option programmatically

          this._changeDetectorRef.markForCheck();
        }

        //  alert('Looking for drivers...');
      }, 1000);
      // this.listenToTripSocket(this.validClient?.userId, ticketId);
      if (this.tripType === 1) {
        return;
      } 
      

      this.listenToTripSocketAccepted(this.validClient?.userId, ticketId,result.max_duration);
      // this.denseLayoutComponent.orderReturnLogic = false;
      // if (!result?.isGitex) {
      this.lookingForDrivers = true;
      this._changeDetectorRef.detectChanges();
      this._changeDetectorRef.markForCheck();
      this._changeDetectorRef.markForCheck();

      console.log('lookingForDrivers', this.lookingForDrivers);
      // title = 'Information';
      // message = 'Notifying drivers of your Trip!';
      // this.openDialog(title, message, this.infoIcon);
      // } else {
      // this.goToTransactionTicket(ticketId);
      // }
      this._changeDetectorRef.markForCheck();
    } else {
      //! If we get activeTrip = true then client already has an active Trip
      //! We display a dialog to cancel it before proceeding
      if (result?.activeTrip && result?.activeTripId) {
        let title = 'Active Trip';
        let message = 'Cancel Active in order to make a new one?';
        this.openDialog(title, message, this.infoIcon, true, () => {
          this;
        });
      } else {
        //? Display Dialog with Error message
        let title = 'Error';
        let message = 'Something not right!';
        // this.openDialog(title, message);
      }

      // this.denseLayoutComponent.orderReturnLogic = false;
      this.orderLoading = false;
      this._splashScreenService.hide();
    }
  }

    
      retour(){
        this.selectedSecteurForm.reset();
        this.currentTripStatus.set(0);
        this.isCanRetryTrip.set(false);
        this.currentTripModeSignal.set(0);
        
        // this.returnToStepOne()
        this.lookingForDrivers = false;
        this.selectStep(0);
        this.isInStepOne=true;
        // this.initFomrs();
        // this.ngOnInit();
         if (this.interval) clearInterval(this.interval);
        this.resetForms();
        this.unsubscribeFromTripUpdate();
        
        this._changeDetectorRef.markForCheck();
        this._router.navigate(['/']);
        
        // this._router.navigate(['/wallet/top-up'], {
        //   queryParams: { driverId: this.driverId, amount: this.amount }
        // });
      }
      async unsubscribeFromTripUpdate() {
  if (this.tripUpdateChannel) {
    console.log('UNSUBSCRIBING FROM TRIP UPDATE...');
    await this.tripUpdateChannel.unsubscribe();
    this.tripUpdateChannel = null;
  }
}

    async updatePassengers(value: number) {

    if(value==1&&this.qtyControl.value<(this.qtySliderPptions.stepsArray?.length || 6)) {
      this.onQtyUpdate(true)

    }
    else {
     if(value==-1 && this.qtyControl.value>1) {
      this.onQtyUpdate(false)

     }
    }

    this._changeDetectorRef.markForCheck();

    }

    async updateLuggage(value: number) {

      if(value === 1 &&   this.luggageControl.value < (this.lggSliderPptions.stepsArray?.length || 6)) {
        this.onLuggageUpdate(true)
      } else {
        if(value==-1 && this.luggageControl.value > 0) {
          this.onLuggageUpdate(false);
        }
      }
      this._changeDetectorRef.markForCheck();
    }
    topUpWallet(){
          // 1. Récupérer les données du formulaire
    const form = this.selectedSecteurForm.getRawValue();
    
    // 2. Préparer les données à sauvegarder
    // const tripData = {
    //   departure_datetime: form.date,
    //   time: form.time,
    //   initial_place_id: form.initial_place_id,
    //   initialLat: form.initialLat,
    //   initialLng: form.initialLng,
    //   initialAddress: form.initialAddress,
    //   destination_place_id: form.destination_place_id,
    //   destinationLat: form.destinationLat,
    //   destinationLng: form.destinationLng,
    //   destinationAddress: form.destinationAddress,
    //   price: form.price,
    //   passengersNb: form.qty,
    //   LuggageNb: form.luggage,
    //   paymentMode: form.paymentMode,
    //   retour: true,
    //   distance: form.distance,
    //   duration: form.duration
    // };

    // 3. Sauvegarder dans le localStorage
    // localStorage.setItem('pendingTripData', JSON.stringify(tripData));

   const amount = btoa(this.totalPriceTTC+"");
   const operation = 'top-up-trip';
   window.location.href = environment.tripassUrl + `/wallet/top-up?amount=${amount}&operation=${operation}`;
  
  }



    // Gère le déplacement au prochain input automatiquement après saisie
  onCodeDigitChange(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (value.length > 1) {
      // Si l'utilisateur colle plus d'un caractère, ne garder que le premier
      input.value = value.charAt(0);
      this.verificationCodeDigits[index] = input.value;
    }

    // Si l'input est vide (ex: touche Backspace) et ce n'est pas le premier champ
    // alors retourner au champ précédent
    if (value === '' && index > 0) {
      const prevInput = document.getElementById('digit-' + (index - 1)) as HTMLInputElement;
      prevInput?.focus();
      return;
    }

    // Passer au champ suivant si une touche numérique a été tapée
    if (value && index < 3) {
      const nextInput = document.getElementById('digit-' + (index + 1)) as HTMLInputElement;
      nextInput?.focus();
    }
    if(this.isVerificationCodeComplete()) {
      this.VerifyCode();
    }

    // Nettoyer l'erreur dès qu'on modifie le code
    this.verificationError = null;
  }
    // Gérer le collage multiple dans les inputs (ex: coller "1234" d’un coup)
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pastedData = event.clipboardData?.getData('text') || '';
    const digits = pastedData.replace(/\D/g, '').slice(0, 4).split('');

    for (let i = 0; i < digits.length; i++) {
      this.verificationCodeDigits[i] = digits[i];
      const input = document.getElementById('digit-' + i) as HTMLInputElement;
      if (input) {
        input.value = digits[i];
      }
    }

    // Focus sur le dernier input collé ou le suivant
    const nextIndex = digits.length < 4 ? digits.length : 3;
    const nextInput = document.getElementById('digit-' + nextIndex) as HTMLInputElement;
    nextInput?.focus();

  }

  // Vérifie si le code est complet (4 chiffres remplis)
  isVerificationCodeComplete(): boolean {
    return this.verificationCodeDigits.every(digit => digit.trim().length === 1);
  }
  async selectType(index: number): Promise<void> {
    console.log('Selected type index:', index);
    // this.selectedType = index;
    this.secondStepForm.patchValue({ forcedType: index});
    this.selectedTypeSignal.set(index);
    this._changeDetectorRef.markForCheck();
    await this.updatePrice();
    this.calculatePriceForm.get('type')?.setValue(index);
    this._changeDetectorRef.markForCheck();
  }

    // Simuler la vérification du code
 
    // Gestion du compte à rebours pour le bouton "Resend Code"
  private startResendCountdown(): void {
    this.canResend = false;
    this.resendCountdown = 30;

    this.countdownSubscription?.unsubscribe();
    this.countdownSubscription = timer(0, 1000).subscribe((sec:any) => {
      this.resendCountdown = 30 - sec;
      if (this.resendCountdown <= 0) {
        this.canResend = true;
        this.countdownSubscription?.unsubscribe();
      }
    });
  }

  // Action pour renvoyer le code (à connecter avec API réelle)
  resendCode(): void {
    this.canResend = false;
    this.resendCountdown = 30;

    // Simuler l'envoi du code
    console.log('Resending verification code to:', this.phone.value);

    // Redémarrer le compte à rebours
    this.startResendCountdown();
  }


    otpTimer = 0;
    isOtpExpired = false;
    isResendDisabled = false;

    startOtpTimer(seconds: number) {
      this.otpTimer = seconds;
      this.isResendDisabled = true;
      this.isOtpExpired = false;
      
      const timer = setInterval(() => {
        this.otpTimer--;
        if (this.otpTimer <= 0) {
          this.isResendDisabled = false;
          this.isOtpExpired = true;
          clearInterval(timer);
        }
        this._changeDetectorRef.markForCheck();
      }, 1000);
    }

    resend() {
      if (this.isResendDisabled) {
        return;
      }
      
      this.clientService.requestOtp({
        phone: this.phone.value,
        country: this.phoneNumber.get('countryNumber')?.value
      }).subscribe({
        next: (response: any) => {
          if (response.otpSent && response.retryAfter) {
            this.startOtpTimer(response.retryAfter);
          }
        },
        error: (error) => {
          console.error('Error sending OTP:', error);
          // En cas d'erreur, on active le bouton de renvoi
          this.isResendDisabled = false;
          this.isOtpExpired = true;
          this._changeDetectorRef.markForCheck();
        }
      });
    }

  async VerifyCode() {

    const code = this.verificationCodeDigits.join('');


        let body={country:  this.thirdStepForm.get('country')!.value,phone:this.phone.value,otp:code}

        console.log('Verifying OTP:', body)


  if (!this.isClient) {
    if (body && body.otp && body.country && body.phone) {
      try {
        const response: any = await lastValueFrom(
          this.clientService.verifyOtp(body)
        );

        console.log('OTP verification successful:', response);

        if (response && response.token) {
          localStorage.setItem('verifyOtpToken', response.token);
          

          await this.completSignUp();
        
          this.showPayement = true;
          await this.fetchWalletInfo();

          const validClient: any = await lastValueFrom(
            this._orderService.checkClientToken()
          );

          if (validClient.success) {
            this.validClient = validClient?.data ?? null;
            this.isClient = true;

            this.listenToDriversBroadcast(
              this.socket,
              this.validClient.userId
            );
            this.listenToWalletBroadcast(
              this.socket,
              this.validClient.userId
            );
          }

          this.loungeStepper.next();
          this._changeDetectorRef.markForCheck();
          this.paymentSelected(this.totalPriceTTC);
        } else {
          this.verificationError =
            this.translateService.translateKey('VERIFICATION_OTP_ERR');
          this.verificationCodeDigits = ['', '', '', ''];
          const firstInput = document.getElementById(
            'digit-0'
          ) as HTMLInputElement;
          firstInput?.focus();
          this._changeDetectorRef.markForCheck();
        }
      } catch (error) {
        console.error('OTP verification failed:', error);
        this.verificationError =
          this.translateService.translateKey('VERIFICATION_OTP_ERR');
        this.verificationCodeDigits = ['', '', '', ''];
        const firstInput = document.getElementById(
          'digit-0'
        ) as HTMLInputElement;
        firstInput?.focus();
        this._changeDetectorRef.markForCheck();
      }
    }
  }



      

    
  }
  async  completSignUp() {
    const [firstName, ...lastNameParts] = this.thirdStepForm.get('name')?.value.split(' ');
    const firstNameField = firstName;
    const lastNameField = lastNameParts.join(' ');
    const resp= await lastValueFrom(this.clientService.completSignUp({firstName:firstNameField,lastName:lastNameField? lastNameField : ' '}));
    if(resp.success) localStorage.setItem('clientToken', resp.token);
    
  }

  openPrivacyPolicy(){
    
  }

  retourToHome(){
    
    this.retour();
  }

    currentLang: string = 'en';
  dropdownOpen = false;

  languages = [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'ar', name: 'العربية', flag: '🇲🇦' }
  ];
selectLanguage(langCode: string) {
  this.currentLang = langCode;
  this.languageService.changeLanguage(langCode);
  localStorage.setItem("preferred_lang", langCode);
  this.dropdownOpen = false;

  // Angular Material locale
  this.adapter.setLocale(this.currentLang);

  // Pour notre mini-moment / native Intl, il suffit de changer activeLang
  this.activeLang = this.currentLang; // utilisé par myMoment.format()
}


  getFlag(langCode: string): string {
    const lang = this.languages.find(l => l.code === langCode);
    return lang ? lang.flag : '';
  }
    toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  loadProfile(imageName:string): string {
    return this.clientService.loadProfile(imageName);
  }
  stepReviewSignal=signal<number>(0);

  review?:Review;
  emojiCode:number = 0;

  onFeedbackSubmitted(feedback: any) {
    console.log('Feedback submitted:', feedback);
    this.emojiCode = feedback.rating;

    this.stepReviewSignal.set(1);
    this._changeDetectorRef.markForCheck();
  }
  async onDriverFeedbackSubmitted(feedback: any) {
    console.log('Driver feedback submitted:', feedback);
    try{
    this.review = {
      orderId: this.ticketId,
      comment: feedback.comment,
      review_emoji: this.emojiCode,
      ratingA: feedback.rating,
      ratingB: feedback.rating,
      ratingC: feedback.rating

    }
    let  reviews= await lastValueFrom(this.clientService.feedbackDriver(this.review))
    console.log('REVIEWS RES ==> ', reviews);
    this.stepReviewSignal.set(2);
    this._router.navigate(['ticket-confirmation-trip', this.ticketId], { relativeTo: this.route, queryParams: {showTicket:this.isShowTicket, notifyDriver:true, downloadTicket:false} });

        
  } catch (error) {
    console.error('Error submitting driver feedback:', error);
  }

    this._changeDetectorRef.markForCheck();
  }

  async handleNotifyDriver(body:{ticketId:string, isHasDriver:boolean}) {
    this.ticketId = body.ticketId;
    let trip= await lastValueFrom(this._orderService.fetchPopularTrip(this.ticketId));
                if((trip.success!=undefined) && !trip.success){
                     const title = this.languageService.translateKey('ERRORS.TITLE')
                       const message = this.languageService.translateKey('ERRORS.TRIP_NOT_FOUND');
                    this.openDialog(title, message, this.successIcon);
                } else {
                console.log('TRIP RES  type ==> ', trip.ticket.tripType);
                this.tripType = trip.ticket.tripType;
                this.ticketData = trip.ticket;
                this.lookingForDrivers= true;
                this._changeDetectorRef.markForCheck();

                this.listenToTripSocketAccepted(this.validClient?.userId, this.ticketId, 400, false);
                if (body.isHasDriver) {
                  // this.isNotifyingDrivers = false;
                  let driverInfo = trip.ticket;
                  this.currentTripStatus.set(driverInfo.status);
                                        this.tripData = {
                        driverId: driverInfo.driverId,
                        driverFullName: driverInfo.driverFullName,
                        driverPhoneNumber:
                        driverInfo.driverPhoneNumber.replace('+', ''),
                        driverPermis: driverInfo.driverPermis,
                        driverCarPlateNumber: driverInfo.taxiPlateNumber,
                        taxiType: driverInfo.taxiType,
                        taxi_num: driverInfo.taxi_num ?? '',
                        driverAvgRatings: driverInfo.driverReviewAvg,
                        driverPhoto: driverInfo.driverPhoto,
                      };


                } else {
                  const resNotif= await lastValueFrom(this.clientService.notifyDrivers(this.ticketId));
                }

                this._changeDetectorRef.markForCheck();
                
    
  }
}
async handleShowticket(event:any){

  try {

  console.log('SHOW TICKET EVENT', event);    this._router.navigate(['ticket-confirmation-trip', this.ticketId], { relativeTo: this.route, queryParams: {showTicket:this.isShowTicket, notifyDriver:true, downloadTicket:false} });

  this.ticketId = event.ticketId;

  let trip= await lastValueFrom(this._orderService.fetchPopularTrip(this.ticketId));


  if(trip) {
  this.tripType = trip.ticket.tripType;
  this.ticketData = trip.ticket;
  this.lookingForDrivers= true;
  this.isShowTicket= true;
      
  if(this.tripType==1){
    this._router.navigate(['ticket-confirmation', this.ticketId], { relativeTo: this.route });
  } else if(!this.isNotifyingDrivers || this.isShowTicket) {
    this._router.navigate(['ticket-confirmation-trip', this.ticketId], { relativeTo: this.route, queryParams: {showTicket:this.isShowTicket, notifyDriver:true, downloadTicket:false} });
  }
                
                
  this._changeDetectorRef.markForCheck();
  } else {
    console.error('Error fetching trip:', trip.message);
  }
}catch (error) {
  console.error('Error fetching trip:', error);
}

  

}

isShowAnimation:boolean=false;

expandPanel() {
  this.isExpanded=true
this.isShowAnimation=true;
}

showLinksCity(id:CityEnum){

  console.log('CITY ENUM ID', id,this.cityName);


  if(this.cityName){
      this.cityId= id
      this._router.navigateByUrl('/city/'+CityEnum[id].toLowerCase());

      console.log('CITY ENUM ID FROM NAME', this.cityId);
  }else  this._router.navigateByUrl('/city/'+CityEnum[id].toLowerCase());
 
}


}
